import React, { Component, createRef } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import { add, capitalize, isEmpty, map, size } from "lodash";
import BreadcrumbClient from "../../components/Common/BreadcrumbClient"
import { withTranslation } from "react-i18next"
import classnames from "classnames"
import ClientLink from "./client-link";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { Formik, Field, Form, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import axios from "axios"
import DeleteModal from "../../components/Common/DeleteModal";
import {
  addClientAddListing, getClientAddListing, getClientDetail, deleteClientAddListing, ClientAddListingUpdate,
  getListingType, getUserDetail, getTransStatusType, getTransCommType, addClientBuyerOffer, updateClientBuyerOffer, getClientBuyerOffer
} from "../../store/actions"
import Moment from 'react-moment';
import CurrencyFormat from 'react-currency-format';
import Switch from "react-switch"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import Dropzone from "react-dropzone"
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import AgentCurrency from "components/dropdowns/Other/getCurrency";
import NoAccess from "components/NoAccess"
import routeImg from "../../assets/img/route-new.png"
import { BlobServiceClient } from '@azure/storage-blob';
import { azureConfig } from "../../helpers/azureConfig";
import Swal from 'sweetalert2'
import messageIcon from "../../assets/img/message-icon-new.png"
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import BootstrapTheme from "@fullcalendar/bootstrap";
import activityIcon from "../../assets/img/run-activity.png"
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import worksheetSubmittedIcon from "../../assets/img/worksheet-submitted-icon.png";
import crossIcon from "../../assets/img/cross-icon.png";
import heartRedIcon from "../../assets/img/heart-red.png";
import heartWhiteIcon from "../../assets/img/heart-white.png";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  InputGroup,
  Button,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Dropdown,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Collapse,
  Input,
  CardHeader,
  Alert,
} from "reactstrap"
import ClientSidebar from "components/VerticalLayout/ClientSidebar";
import UpdateButton from "components/buttons/updateBtn";
import RsLink from "components/buttons/rsLink";
import SaveButton from "components/buttons/save";
import ClientBuyerBreadcrumbs from "components/Common/ClientBuyerBreadcrumb";
import ClientBuyerMenu from "./menu/client-buyer-menu";
import buyer from "pages/Lead/questions/buyer";
import ClientEngagementList from "components/dropdowns/Lead/EngagementList";
import CurrencyInput from "react-currency-input-field";
import { API_URL } from "helpers/app_url";
import moment from "moment";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import AiButton from "components/buttons/aiBtn";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import TimePicker from "components/dropdowns/Timepicker";
import { MultiSelect } from "primereact/multiselect";
import EngagementListBuyerClient from "components/dropdowns/Lead/EngagementListBuyerClient";
import PhoneInputField from "components/dropdowns/PhoneInputField";
import FilterBuyerDeal from "components/dropdowns/Lead/FilterBuyerDeal";
import { UPLOADTEXT } from "constants/layout";
import SafeField from "helpers/SafeField";
import { hasPermission } from "helpers/checkPermission";
class ClientListing extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab1: "1",
      activeTab2: "1",
      addListing: '',
      activeFilter: 'All',
      showEditForm: false,
      selectedRoute: null,
      listingType: '0',
      filteredListings: this.props.addListings || [],
      filterAddListing: this.props.addListings || [],
      searchQuery: '',
      showingListings: [],
      allConditions: [],
      lightboxOpen: false,
      photoIndex: 0,
      noFound: false,
      selectedDeal: "",
      expandedRows: null

    }
    this.calendarRef = createRef();
    this.handleAddListingSubmit = this.handleAddListingSubmit.bind(this)
    this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
    this.toggleBackdrop = this.toggleBackdrop.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
    this.toggle1 = this.toggle1.bind(this);
    this.toggle2 = this.toggle2.bind(this);
    this.toggleCreateRoute = this.toggleCreateRoute.bind(this);
    this.canavasbuyeractivity = this.canavasbuyeractivity.bind(this);
    //this.offerSubmitted = this.offerSubmitted.bind(this)
    this.handleSubmitMessage = this.handleSubmitMessage.bind(this);
    this.handleSubmitResuchedule = this.handleSubmitResuchedule.bind(this);
    this.dt = createRef();
    this.statusOptions = [
      { label: "Available", value: 1 },
      { label: "Not Available", value: 2 },
      { label: "Sold", value: 3 },
      { label: "Sold Conditionally", value: 3 },
    ];
  }
  postActivity = async () => {
    try {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const payload = {
        activityTypeId: [0],
        activityFromDate: moment().startOf("month").format("YYYY-MM-DD"),
        activityToDate: moment().add(6, "months").endOf("month").format("YYYY-MM-DD"),
        //refId: parseInt(this.props.match.params.id),
        //refTypeId:2,
        agentId: parseInt(localStorage.getItem('userId'))
      };

      const response = await axios.post(
        `${API_URL}Activity/allfilteredactivities`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          }
        }
      );

      //
      const rawEvents = response.data || [];
      const events = rawEvents.map(event => {

        const start = moment(
          `${event.activityStartDate.split("T")[0]} ${event.startTime}`,
          "YYYY-MM-DD hh:mm A"
        ).format("YYYY-MM-DDTHH:mm:ss");

        const end = moment(
          `${event.activityStartDate.split("T")[0]} ${event.endTime}`,
          "YYYY-MM-DD hh:mm A"
        ).format("YYYY-MM-DDTHH:mm:ss");
        const eventStartDate = new Date(start);
        const now = new Date();
        return {
          id: event.activityActivityId,
          title: event.displayTitle,
          start,
          end,
          className: eventStartDate < now ? 'bg-danger text-white' : 'bg-success text-white',
          extendedProps: {
            description: event.activityNotes,
            agentId: event.agentId,
            contactName: event.contactName,
            contactPhone: event.contactPhone,
            contactEmail: event.contactEmail,
            location: event.activityLocation,
          }
        };
      });

      this.setState({ resultArray: events, isLoading: false, });
    } catch (error) {
      console.error("Error posting activity:", error);
    }
  };
  handleOpenLightbox = (index) => {
    this.setState({ lightboxOpen: true, photoIndex: index });
  };
  handleInputChange = (e) => {
    this.setState({ searchQuery: e.target.value }, this.filterListings);
  };
  getStatus = (status) => {
    if (status == 1)
      return 'Available';
    else if (status == 2)
      return 'Not Available';
    else if (status == 3)
      return 'Sold';
    else if (status == 4)
      return 'Sold Conditionally'
  }

  fetchClientActivity() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;

    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const body = {
      agentId: parseInt(localStorage.getItem("userId")),
      clientId: parseInt(this.props.match.params.id),
      typeIds: [1],
    };

    axios
      .post(`${API_URL}ClientListingActivity/allforagenttype`, body, { headers })
      .then((response) => {
        this.setState({ clientActivities: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }

  getListingSubType = (type) => {
    if (type == 1)
      return 'Listing Added';
    else if (type == 2)
      return 'Scheduled';
    else if (type == 3)
      return 'Re-scheduled Request';
    else if (type == 5)
      return 'Message';
    else if (type == 6)
      return 'Offer sent';
    else if (type == 7)
      return 'Offer Accepted';
    else if (type == 8)
      return 'Widthdrawn';
    else if (type == 9)
      return 'Rejected';
  }
  handleAcceptedFiles = async (acceptedFiles) => {

    const filesWithPreview = acceptedFiles.map(file => {
      file.preview = URL.createObjectURL(file);
      file.formattedSize = this.formatBytes(file.size);
      return file;
    });

    this.setState({ selectedFiles: filesWithPreview });

    filesWithPreview.forEach(file => this.uploadFileToAzure(file));
  };

  uploadFileToAzure = async (file) => {
    const maxSize = 2 * 1024 * 1024; // 5 MB
    const allowedTypes = ['image/jpeg', 'image/png'];
    const allowedExtensions = ['.jpg', '.jpeg', '.png'];
    const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();

    // Validate file type
    if (!allowedTypes.includes(file.type) || !allowedExtensions.includes(fileExtension)) {
      Swal.fire({
        title: 'File type or extension not allowed',
        text: 'Please upload only .jpg, jpeg, .png, .webp, .svg.',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
      return;
    }

    // Validate file size
    if (file.size > maxSize) {
      Swal.fire({
        title: 'File size exceeded',
        text: 'Please upload a file smaller than 2MB.',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
      return;
    }
    const sasToken = azureConfig.sasToken
    const containerName = azureConfig.containerName;
    const accountName = azureConfig.storageAccountName;


    const blobServiceClient = new BlobServiceClient(
      `https://${accountName}.blob.core.windows.net?${sasToken}`
    );
    const fileName = `${Date.now()}_${file.name}`;
    const containerClient = blobServiceClient.getContainerClient(containerName);
    const blockBlobClient = containerClient.getBlockBlobClient(fileName);

    try {
      toast.loading('please wait...');

      await blockBlobClient.uploadBrowserData(file);
      const fileUrl = `https://${accountName}.blob.core.windows.net/${containerName}/${fileName}`;
      const payload = {
        "clientShowingId": this.state.addListing?.id,
        "clientPotentialListingImageTitle": fileName,
        "clientPotentialListingImageLink": fileUrl,
        "clientPotentialListingImageTypeId": 0,
        "clientPotentialListingImageStorageType": 0,
        "agentId": parseInt(localStorage.getItem('userId')),
        "isActive": true
      }
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const apiUrl = `${API_URL}ClientPotentialListingImage`
      const method = "post";
      const response = await axios({
        method,
        url: apiUrl,
        data: payload,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200 || response.status === 201) {
        toast.dismiss();
        toast.success("Saved successfully")
        this.fetchImages(this.state.addListing?.id);
      }
    } catch (error) {
      console.error('Error uploading file to Azure Blob Storage', error);
    }
  };
  fetchImages(listingId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    const params = {
      ClientId: this.props.match.params.id,
      ShowingId: listingId,
      agentId: localStorage.getItem('userId')
    }
    axios
      .get(`${API_URL}ClientPotentialListingImage/allbyshowing/`, { headers, params })
      .then((response) => {
        this.setState({ imagesData: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  };
  handleSubmitResuchedule = async (values, { setSubmitting, resetForm }) => {
    try {
      toast.loading("please wait...");

      const payload = {
        id: values.id,
        clientPotentialListingId: values.clientPotentialListingId,
        clientId: parseInt(values.clientId),
        agentId: parseInt(values.agentId),
        notes: values.notes,
        showingDate: moment(values.showingDate).format("YYYY-MM-DD"),
        startTime: values.startTime,
        endTime: values.endTime,
        showingStatus: "Scheduled",
        showingStatusId: 1,
        clientNotes: values.clientNotes
      }
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const apiUrl = `${API_URL}ClientPotentialListing/ScheduleClientPotentialListingShowing`
      const method = "put";
      const response = await axios({
        method,
        url: apiUrl,
        data: payload,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200 || response.status === 201) {
        toast.dismiss();
        toast.success("Saved successfully.")
        const { onGetClientAddListing } = this.props;

        onGetClientAddListing(this.props.match.params.id, localStorage.getItem('userId'));
        this.toggleRight();
      }
    } catch (error) {
      console.error("Error submitting form:", error);

    } finally {
      setSubmitting(false);
    }
  }
  handleSubmitMessage = async (values, { setSubmitting, resetForm }) => {
    try {
      toast.loading("please wait...");

      const payload = {
        clientPotentialListingMessageBy: values.clientPotentialListingMessageBy,
        clientPotentialListingId: parseInt(values.clientPotentialListingId),
        scheduleDate: moment(values.scheduleDate).format("YYYY-MM-DD"),
        notes: values.notes,
        agentId: parseInt(localStorage.getItem('userId'))
      }
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const apiUrl = `${API_URL}ClientPotentialListingMessage`
      const method = "post";
      const response = await axios({
        method,
        url: apiUrl,
        data: payload,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200 || response.status === 201) {
        toast.dismiss();
        toast.success("Saved successfully")
        this.fetchMessage(values.clientPotentialListingId);
        this.toggleRight();
      }
    } catch (error) {
      console.error("Error submitting form:", error);

    } finally {
      setSubmitting(false);
    }
  }
  fetchMessage(listingId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    const clientId = this.props.match.params.id;
    const agentId = localStorage.getItem('userId');
    axios
      .get(`${API_URL}ClientPotentialListingMessage/${listingId}?clientId=${clientId}&agentId=${agentId}`, { headers })
      .then((response) => {
        this.setState({ messageData: response.data, loadings: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loadings: false });
      });
  }
  updateMessage(listingId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    const payload = {
      clientPotentialListingId: listingId,
      agentId: parseInt(localStorage.getItem('userId'))
    }
    axios
      .post(`${API_URL}ClientPotentialListingMessage/ClearClientPotentialListingMessageNewFlag`, payload, { headers })
      .then((response) => {
        const { match: { params }, onGetClientAddListing, } = this.props;
        onGetClientAddListing(params.id, localStorage.getItem('userId'));
      })
      .catch((error) => {

      });
  }
  toggleBackdrop() {
    this.setState({ isBackdrop: !this.state.isBackdrop });
  }
  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
    }));
  };
  onClickDelete = (addListing) => {
    this.setState({ addListing: addListing });
    this.setState({ deleteModal: true });
  };
  toggleRight() {
    this.setState(prevState => ({
      isRight: !prevState.isRight,
      activeTab1: !prevState.isRight ? "1" : prevState.activeTab1,
    }));


  }

  toggle1(tab) {
    if (this.state.activeTab1 !== tab) {
      this.setState({
        activeTab1: tab,
      });
    }
  }

  toggle2(tab) {
    if (this.state.activeTab2 !== tab) {
      this.setState({
        activeTab2: tab,
      });
    }
  }
  handleDeleteAddListing = () => {
    const { onDeleteAddListing } = this.props;
    const { addListing } = this.state;

    if (addListing.id !== undefined) {
      onDeleteAddListing(addListing);
      this.setState({ deleteModal: false });
      this.toggleRight();
    }
  };
  toggleCreateRoute() {
    this.setState({ addListing: "", isRoute: !this.state.isRoute });
  }
  canavasbuyeractivity() {
    this.setState({ buyerActivity: "", isActivity: !this.state.isActivity });
  }
  handlePlaceSelected = (address, index, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;

        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        setFieldValue(`createClientPotentialListingLists.${index}.listingAddress`, place.formatted_address);
        setFieldValue(`createClientPotentialListingLists.${index}.listingCity`, getComponent(['locality', 'political']));

        //setFieldValue('longitude', longitude);
        //setFieldValue('latitude', latitude);
      })
      .catch(error => console.error('Error', error));
  };
  handleEditPlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;

        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };
        setFieldValue('listingAddress', place.formatted_address);
        setFieldValue('listingCity', getComponent(['locality', 'political']));
      })
      .catch(error => console.error('Error', error));
  };
  handleAddListingSubmit = (values, actions) => {
    values.createClientPotentialListingLists.forEach(listing => {
      const payload = {
        clientId: parseInt(listing.clientId),
        agentId: parseInt(listing.agentId),
        engagementId: parseInt(listing.engagementId),
        mlsId: listing.mlsId,
        mlsurl: listing.mlsurl,
        listingDate: listing.listingDate,
        listingStatusId: 1,
        isInterested: listing.isInterested,
        isActive: listing.isActive,
        addedBy: listing.addedBy,
        listedPrice: listing.listedPrice ? parseInt(listing.listedPrice) : 0,
        listingType: listing.listingType ? parseInt(listing.listingType) : 0,
        listingBedroom: listing.listingBedroom,
        listingBathroom: listing.listingBathroom,
        listingParking: listing.listingParking ? parseInt(listing.listingParking) : 0,
        listingAddress: listing.listingAddress,
        listingSqFt: listing.listingSqFt,
        listingCity: listing.listingCity,
        notes: listing.notes,
        statusId: 0
      };
      this.props.addClientAddListing(payload, (status) => {
        if (status == true) {
          actions.resetForm();
        }
      });

    });




  }
  componentDidMount() {
    const { match: { params }, onGetClientDetail, onGetClientAddListing, onGetListingType, onGetUserDetail, onGetTransactonStatusType, onGetTransactonCommType } = this.props;
    onGetClientDetail(params.clientId);
    onGetClientAddListing(params.id, localStorage.getItem('userId'));
    onGetListingType(localStorage.getItem('userId'))
    onGetUserDetail(localStorage.getItem('userId'))
    onGetTransactonStatusType(localStorage.getItem('userId'), 'Buyer');
    onGetTransactonCommType(localStorage.getItem('userId'));
    this.fetchRouteData();
    this.filterListings();
    this.fetchClientActivity();
    this.fecthConditions();


    const offcanvas = document.getElementById("myOffcanvas");

    if (offcanvas) {
      offcanvas.addEventListener("shown.bs.offcanvas", this.handleOffcanvasShown);
    }

  }
  componentWillUnmount() {
    const offcanvas = document.getElementById("myOffcanvas");

    if (offcanvas) {
      offcanvas.removeEventListener("shown.bs.offcanvas", this.handleOffcanvasShown);
    }
  }
  handleOffcanvasShown = () => {
    const calendarApi = this.calendarRef.current?.getApi();
    if (calendarApi) {
      calendarApi.render();
    }
  };
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { addListings } = this.props;
    if (!isEmpty(addListings) && size(prevProps.addListings) !== size(addListings)) {
      this.setState({ addListings: {}, isEdit: false });

      this.setState({
        filterAddListing: this.props.addListings,
      }, this.filterListings);
    }

    //this.filterListings();
  }
  toggleRightCanvas() {
    this.setState({ addListing: "", isEdit: false, isRight: !this.state.isRight });
    this.toggleRight();
  }

  toggleRightCanvas = arg => {
    const addListing = arg;

    this.setState({
      addListing: {

        id: addListing.id,
        clientPotentialListingId: addListing.clientPotentialListingId,
        clientId: addListing.clientId,
        agentId: addListing.agentId,
        mlsId: addListing.mlsId,
        mlsurl: addListing.mlsurl,
        listingDate: addListing.listingDate,
        listingStatusId: addListing.listingStatusId,
        isInterested: addListing.isInterested,
        engagementId: addListing.engagementId,
        isActive: addListing.isActive,
        addedBy: addListing.addedBy,
        listedPrice: addListing.listedPrice,
        listingType: addListing.listingType,
        listingBedroom: addListing.listingBedroom,
        listingBathroom: addListing.listingBathroom,
        listingParking: addListing.listingParking,
        listingSqFt: addListing.listingSqFt,
        listingAddress: addListing.listingAddress,
        listingCity: addListing.listingCity,
        notes: addListing.notes,
        showingDate: addListing.showingDate,
        startTime: addListing.startTime,
        endTime: addListing.endTime,
        showingStatus: addListing.showingStatus,
        showingStatusId: addListing.showingStatusId,
        clientNotes: addListing.clientNotes,
        likeDislike: addListing.likeDislike,
        statusId: addListing.statusId,
        feedback: addListing.feedback,
        transactionStatus: addListing.transactionStatus
      },
      isEdit: true,
    });

    // this.fetchMessage(addListing.id);
    // this.updateMessage(addListing.id)
    // this.fetchImages(addListing.id);
    // this.fetchListingShowingHistory(addListing.id);
    if (addListing.id > 0) {
    this.fetchMessage(addListing.id);
    this.updateMessage(addListing.id);
    this.fetchImages(addListing.id);
    this.fetchListingShowingHistory(addListing.id);
  }
    this.toggleRight();
  };
  offertoggle() {
    this.setState(prevState => ({
      isOffer: !prevState.isOffer,
    }));
  }
  toggleOfferAccepted() {
    this.setState({ isOffer: !this.state.isOffer });
  }

  toggleOfferAccepted = arg => {
    const addListing = arg;

    const { onGetClientBuyerOffer } = this.props;
     if (addListing.id > 0) {
        onGetClientBuyerOffer(addListing.id);
     }
    this.setState({
      addListing: {
        id: addListing.id,
        agentId: addListing.agentId,
        mlsId: addListing.mlsId,
        mlsurl: addListing.mlsurl,
        listingStatusId: addListing.listingStatusId,
        listingType: addListing.listingType,
        listingAddress: addListing.listingAddress,
        listedPrice: addListing.listedPrice,
        engagementId: addListing.engagementId,
        buyerType: addListing?.clientEngagementInfo?.buyerType,
        startDate: addListing?.clientEngagementInfo?.startDate,
        endDate: addListing?.clientEngagementInfo?.endDate,
      },
    });
    this.offertoggle();
  };
  handleChange = (activeStatus, itemId) => {

  };
  handleTabClick = (tabName) => {
    this.setState({ activeFilter: tabName });

  };

  offerSubmitted = (values) => {
    const allConditions = this.state.allConditions;
    const agentId = parseInt(localStorage.getItem('userId'));
    const clientDealConditionStates = allConditions.map(condition => ({
      id: 0, // For new record
      clientDealConditionStateId: '68a459a7-384c-8331-84dd-4e59fb091ee2',
      clientDealConditionId: condition.id,
      clientListingId: parseInt(values.refId),
      clientOfferId: 0,
      clientId: parseInt(values.clientId),
      agentId: agentId,
      status: values.conditions.includes(condition.id.toString()),
      isActive: true
    }));
    const payload = {
      agentId: parseInt(localStorage.getItem('userId')),
      clientId: parseInt(values.clientId),
      propertyURL: values.propertyURL,
      propertyType: values.propertyType,
      propertyAddress: values.propertyAddress,
      transTypeId: 2,
      //commissionTypeId: parseInt(values.commissionTypeId),
      //commisisonValue: parseInt(values.commisisonValue),
      askingPrice: parseInt(values.askingPrice),
      offerPrice: values.offerPrice ? parseInt(values.offerPrice) : 0,
      offerDate: (values.offerDate) ? moment(values.offerDate).format('YYYY-MM-DD') : null,
      closingDate: (values.closingDate) ? moment(values.closingDate).format('YYYY-MM-DD') : null,
      expiryDate: (values.expiryDate) ? moment(values.expiryDate).format('YYYY-MM-DD') : null,
      expiryTime: values.expiryTime,
      agreementStartDate: (values.agreementStartDate) ? moment(values.agreementStartDate).format('YYYY-MM-DD') : null,
      agreementEndDate: (values.agreementEndDate) ? moment(values.agreementEndDate).format('YYYY-MM-DD') : null,
      deposit: values.deposit ? parseInt(values.deposit) : 0,
      refId: parseInt(values.refId),
      refTypeId: 1,
      statusId: parseInt(values.statusId),
      isAccepted: '',
      conditions: '',
      notes: values.notes,
      engagementId: parseInt(values.engagementId),
      agentName: values.agentName,
      agentMobile: values.agentMobile,
      agentEmail: values.agentEmail,
      agentOffice: values.agentOffice,
      agentOfficeName: values.agentOfficeName,
      agentOfficePhone: values.agentOfficePhone,
      clientName: values.clientName,
      clientMobile: values.clientMobile,
      clientPhone: values.clientPhone,
      clientEmail: values.clientEmail,
      clientDealConditionStates: clientDealConditionStates,
    }
    this.props.addClientBuyerOffer(payload);
    this.offertoggle();
  };
  offerUpdated = (values) => {



    const selectedConditions = this.props.buyeroffer?.clientDealConditionStates || [];
    const allConditions = this.state.allConditions || [];
    const agentId = parseInt(localStorage.getItem('userId'), 10);
    const clientDealConditionStates = allConditions.map(condition => {
      const existingCondition = selectedConditions.find(c => c.clientDealConditionId === condition.id);

      return {
        id: existingCondition ? existingCondition.id : 0,
        clientDealConditionStateId: existingCondition ? existingCondition.clientDealConditionStateId : '68a459a7-384c-8331-84dd-4e59fb091ee2',
        clientDealConditionId: condition.id,
        clientListingId: parseInt(values.refId, 10),
        clientOfferId: parseInt(values.id, 10),
        clientId: parseInt(this.props.match.params.id, 10),
        agentId: agentId,
        status: values.conditions?.includes(condition.id.toString()) || false,
        isActive: true
      };
    });


    const payload = {
      id: parseInt(values.id),
      offerId: values.offerId,
      agentId: parseInt(localStorage.getItem('userId')),
      clientId: parseInt(this.props.match.params.id),
      propertyURL: values.propertyURL,
      propertyType: values.propertyType,
      propertyAddress: values.propertyAddress,
      transTypeId: 2,
      //commissionTypeId: parseInt(values.commissionTypeId),
      //commisisonValue: parseInt(values.commisisonValue),
      askingPrice: parseInt(values.askingPrice),
      offerPrice: values.offerPrice ? parseInt(values.offerPrice) : 0,
      offerDate: (values.offerDate) ? moment(values.offerDate).format('YYYY-MM-DD') : null,
      closingDate: (values.closingDate) ? moment(values.closingDate).format('YYYY-MM-DD') : null,
      expiryDate: (values.expiryDate) ? moment(values.expiryDate).format('YYYY-MM-DD') : null,
      expiryTime: values.expiryTime,
      agreementStartDate: (values.agreementStartDate) ? moment(values.agreementStartDate).format('YYYY-MM-DD') : null,
      agreementEndDate: (values.agreementEndDate) ? moment(values.agreementEndDate).format('YYYY-MM-DD') : null,
      deposit: values.deposit ? parseInt(values.deposit) : 0,
      refId: parseInt(values.refId),
      refTypeId: 1,
      statusId: parseInt(values.statusId),
      isAccepted: '',
      conditions: '',
      notes: values.notes,
      engagementId: parseInt(values.engagementId),
      agentName: values.agentName,
      agentMobile: values.agentMobile,
      agentEmail: values.agentEmail,
      agentOffice: values.agentOffice,
      agentOfficeName: values.agentOfficeName,
      agentOfficePhone: values.agentOfficePhone,
      clientName: values.clientName,
      clientMobile: values.clientMobile,
      clientPhone: values.clientPhone,
      clientEmail: values.clientEmail,
      clientDealConditionStates: clientDealConditionStates,
    }
    this.props.updateClientBuyerOffer(payload, (status) => {
      if (status == true) {
        this.offertoggle();
      }
    });

  };
  fetchRouteData = async () => {
    const agentId = localStorage.getItem('userId');
    const clientId = this.props.match.params.id;
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    try {
      const response = await axios.get(
        `${API_URL}ClientPotentialListingsShowingRoute/fixedAllGrouped?AgentId=${agentId}&ClientId=${clientId}`,
        { headers } // Passing headers
      );
      this.setState({ routeData: response.data });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  toggleCollapse = (index) => {
    this.setState((prevState) => ({
      [`col${index}`]: !prevState[`col${index}`],
    }));
  };

  handleDeleteRoute = (route) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        axios
          .delete(`${API_URL}ClientPotentialListingsShowingRoute/${route.id}`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
          .then((response) => {
            Swal.fire("Deleted!", "Route has been deleted.", "success");
            this.fetchRouteData();
          })
          .catch((error) => {
            Swal.fire("Error!", "An error occurred while deleting the route.", "error");
          });
      }
    });
  }
  editRoute = (route) => {
    this.setState({
      showEditForm: true,
      selectedRoute: route,
    });
  };

  handleListingTypeChange = (e) => {
    this.setState({ listingType: e.target.value }, this.filterListings);
  };


  filterListings = () => {
    const { searchQuery, listingType } = this.state;
    const { addListings } = this.props;
    const today = new Date();
    const filtered = addListings?.filter((listing) => {
      const matchesSearch =
        listing.mlsId.toLowerCase().includes(searchQuery.toLowerCase()) ||
        listing.listingCity.toLowerCase().includes(searchQuery.toLowerCase());
      let matchesType = false;
      switch (listingType) {
        case '0':
          matchesType = true;
          break;
        case '1':

          const showingDate = new Date(listing.showingDate);
          matchesType = listing.showingStatusId === 1 && showingDate > today;
          break;
        case '2':
          matchesType = listing.showingStatusId === 1;
          break;
        case '3':

          matchesType = listing.addedBy === 'agent';
          break;
        case '4':
          matchesType = listing.addedBy === 'client';
          break;

        case '5':
          matchesType = listing.showingStatusId !== 1;
          break;
        default:
          matchesType = true;
      }


      return matchesSearch && matchesType;
    });

    this.setState({ filterAddListing: filtered });
  };



  handleInsertAi = (generatedText, setFieldValue) => {
    //
    setFieldValue("notes", generatedText);
  };

  handleForDateTimeChange = (value) => {
    const clientId = parseInt(this.props.match.params.id);
    const agentId = parseInt(localStorage.getItem("userId"));

    const formattedDate = moment(value.forDate).format("YYYY-MM-DD");
    const formattedTime = value.forTime;
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    axios.get(`${API_URL}ClientPotentialListingsShowingRoute/forDateNTime`, {
      params: {
        AgentId: agentId,
        ClientId: clientId,
        forDate: formattedDate,
        forTime: formattedTime
      },
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
      .then(response => {
        //
        
        this.setState({
          showingListings: response.data || [],
          forDate: value.forDate,
          forTime: value.forTime,
          noFound: true
        });
      })
      .catch(error => {
        console.error("API Error:", error);
      });
  }
  getType = (type) => {
    if (type == 1)
      return 'Buyer';
    else if (type == 2)
      return 'Seller';
    else if (type == 3)
      return 'Openhouse';
  }
  fetchEvents = async (startDate, endDate) => {
    try {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;

      const response = await axios.get(
        `${API_URL}Google/GetGoogleEventsFromLocalFarDateRange?code=32B46870-DC67-4FD0-84E5-ECD7B5673691&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const rawEvents = response.data;

      const events = rawEvents.map(event => ({
        id: event.id,
        title: event.summary,
        start: event.startTime,
        end: event.endTime,
        url: event.htmlLink,
        extendedProps: {
          description: event.description,
          agentId: event.agentId,
          calendarId: event.calendarId,
          calendarDetailId: event.calendarDetailId,
          eventPageType: event.eventPageType,
          eventPageId: event.eventPageId,
        },
      }));

      this.setState({ events });
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  formatDate = (input) => {
    const date = new Date(input);
    if (isNaN(date)) return ""; // fallback if invalid
    return date.toISOString().split("T")[0];
  };
  fecthConditions = () => {
    const authUser = localStorage.getItem("authUser");
    if (!authUser) return;
    const obj = JSON.parse(authUser);
    const token = obj?.resultData?.bearerToken;
    if (!token) return;
    const str = 'Bearer ' + token;
    axios.get(`${API_URL}ClientDealCondition/allforagenttype`, {
      params: {
        agentId: parseInt(localStorage.getItem("userId")),
        forType: 1
      },
      headers: { Authorization: str }
    })
      .then(res => this.setState({ allConditions: res.data }))
      .catch(err => console.error("Error fetching templates:", err));
  }
  handleDeleteImage = (imageId, index) => {
    

    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    Swal.fire({
      title: "Are you sure?",
      text: "This image will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${API_URL}ClientPotentialListingImage/${imageId}`, { headers })
          .then((response) => {
            

            if (response.status === 200 || response.status === 204) {
              Swal.fire("Deleted!", "Your image has been deleted.", "success");

              const updatedImages = [...this.state.imagesData];
              updatedImages.splice(index, 1);
              this.setState({ imagesData: updatedImages });
            } else {
              Swal.fire("Error!", "Failed to delete image!", "error");
            }
          })
          .catch((error) => {
            console.error("Delete Error:", error);
            Swal.fire("Error!", "Something went wrong!", "error");
          });
      }
    });
  };

  fetchListingShowingHistory(listingId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    const params = {
      clientId: this.props.match.params.id,
      agentId: localStorage.getItem('userId'),
      listingId: listingId
    }
    axios
      .get(`${API_URL}ClientPotentialListingShowingHistory/allbylistingid`, { headers, params })
      .then((response) => {
        this.setState({ schedules: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }

  handleDeleteShowing = (listing) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const payload = {
      id: listing.id,
      clientPotentialListingId: listing.clientPotentialListingId,
      clientId: listing.clientId,
      agentId: listing.agentId,
      engagementId: listing.engagementId,
      notes: "",
      showingDate: null,
      startTime: "",
      endTime: "",
      showingStatus: "",
      showingStatusId: 0,
      clientNotes: ""
    };
    toast.loading('Please wait....')
    axios
      .put(`${API_URL}ClientPotentialListing/DeleteClientPotentialListingShowing`, payload, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200 || response.status === 204) {
          toast.dismiss();
          toast.success("Deleted successfully")
          this.toggleRight();
        } else {
          toast.dismiss();
          toast.warn('Some error please try after some time')
        }

      })
      .catch((error) => {

      });
  };

  dateTemplate = (row) => (
    <>
      {row.isInterested && (
        <img
          src={worksheetSubmittedIcon}
          width={16}
          style={{ verticalAlign: "middle", marginTop: "-2px" }}
          alt=""
        />
      )}{" "}
      <Moment format="DD MMM, YYYY">{row.listingDate}</Moment>
    </>
  );

  idTemplate = (row) => (
    row.mlsurl ? (
      <a href={row.mlsurl} target="_blank" rel="noreferrer">

        {row.isFavourite ? (
          <img
            src={heartRedIcon}
            alt="favourite"
            className="me-2"
            style={{ verticalAlign: "middle", marginLeft: "5px", height: 16, }}
          />
        ) : (
          <img
            src={heartWhiteIcon}
            alt="favourite"
            className="me-2"
            style={{ verticalAlign: "middle", marginLeft: "5px", height: 16 }}
          />
        )}

        {row.mlsId}

        <i className="bx bx-link-external" style={{ marginLeft: "5px" }} />
      </a>
    ) : (
      <>
        {row.isFavourite ? (
          <img
            src={heartRedIcon}
            alt="favourite"
            className="me-2"
            style={{ verticalAlign: "middle", marginTop: "-2px", height: 16, marginRight: "5px" }}
          />
        ) : (
          <img
            src={heartWhiteIcon}
            alt="favourite"
            className="me-2"
            style={{ verticalAlign: "middle", marginLeft: "5px", height: 16 }}
          />
        )}
        <span>{row.mlsId}</span>
      </>
    )
  );


  priceTemplate = (row) => (
    <CurrencyFormat
      value={row.listedPrice}
      displayType={"text"}
      thousandSeparator
      prefix={this.props.userdetail?.agentDefaultCurrencyCode + " "}
    />
  );

  showingTemplate = (row) =>
    row.showingDate ? (
      <>
        <Moment format="MMM DD">{row.showingDate}</Moment> / {row.startTime || "N/a"}
      </>
    ) : (
      "N/a"
    );

  actionTemplateOld = (row) => (
    <>
      <Link to="#" className="header-item noti-icon-mesaage me-3">
        <img src={messageIcon} style={{ width: 32 }} alt="" />
        <span className="badge bg-blue bg-danger rounded-pill">{row.newMessageCount}</span>
      </Link>{" "}
      <Link to="#" className="btn btn-action" onClick={() => this.toggleRightCanvas(row)}>
        Manage
      </Link>{" "}
      {row.listingStatusId === 1 &&
        (!row.anyAcceptedOffer ||
          (row.anyAcceptedOffer &&
            ["Offer Accepted", "Offer Submitted"].includes(row.transactionStatus?.title))) ? (
        <Link to="#" className="btn btn-green" onClick={() => this.toggleOfferAccepted(row)}>
          Offer
        </Link>
      ) : (
        <button className="btn btn-green-disabled" disabled>
          Offer
        </button>
      )}
    </>
  );
  actionTemplate = (row) => (
    <>
      <Link to="#" className="header-item noti-icon-mesaage me-3">
        <img src={messageIcon} style={{ width: 32 }} alt="" />
        <span className="badge bg-blue-v2 bg-danger rounded-pill">{row.newMessageCount}</span>
      </Link>{" "}
      <Link
        to="#"
        className="btn btn-action"
        onClick={() => this.toggleRightCanvas(row)}
      >
        Manage
      </Link>{" "}
      {row.listingStatusId === 1 ? (
        (!row.anyAcceptedOffer ||
          (row.anyAcceptedOffer &&
            ["Offer Accepted", "Offer Submitted"].includes(
              row.transactionStatus?.title
            ))) ? (
          <Link
            to="#"
            className="btn btn-green"
            onClick={() => this.toggleOfferAccepted(row)}
          >
            {row.transactionStatus?.title || "Offer"}
          </Link>
        ) : (
          <button className="btn btn-green-disabled" disabled>
            Active deal exists
          </button>
        )
      ) : (
        <button className="btn btn-green-disabled" disabled>Property not available </button>
      )}
      {row.IsListingDeleteAllowed == true && (
        <ActionDelete onClick={() => this.onClickDelete(row)} />
      )}
    </>
  );

  cityFilterTemplate = (options) => {
    const uniqueCities = [...new Set(this.props.addListings.map(l => l.listingCity))];
    const cityOptions = uniqueCities.map(city => ({ label: city, value: city }));

    return (
      <MultiSelect
        value={options.value}
        options={cityOptions}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder="Filter Cities"
        className="p-column-filter"
        display="chip"
      />
    );
  };

  getStatus = (statusId) => {
    const status = this.statusOptions.find((s) => s.value === statusId);
    return status ? status.label : null;
  };


  statusFilterTemplate = (options) => {
    return (
      <MultiSelect
        value={options.value}
        options={this.statusOptions}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder="Filter Status"
        className="p-column-filter"
        display="chip"
      />
    );
  };

handleFilterTypeChange = (e) => {
  const value = e.target.value;
  let filters = { ...this.state.filters };

  if (value === "") {
    delete filters.addedBy;
    delete filters.isInterestedToView;
    delete filters.isFavourite;
  } else if (value === "byClient") {
    filters.addedBy = { value: "client", matchMode: "equals" };
    delete filters.isInterestedToView;
  } else if (value === "byAgent") {
    filters.addedBy = { value: "agent", matchMode: "equals" };
    delete filters.isInterestedToView;
  } else if (value === "intView") {
    filters.isInterested = { value: true, matchMode: "equals" };
    delete filters.addedBy;
  }else if (value === "intFav") {
    filters.isFavourite = { value: true, matchMode: "equals" };
    delete filters.addedBy;
  }

  this.setState({ 
    filters,
    selectedFilterType: value
  });
};
  render() {
    const { lightboxOpen, photoIndex } = this.state;
    const { clietDetail, listingtypes, addListings, onUpdateClientAddListing, userdetail, transStatusTypes, transactionCommTypes, buyeroffer, isResponsive } = this.props;
    //
    const { isEdit, deleteModal, addListing, activeFilter, messageData, imagesData, routeData, newrouteData, showingListings, allConditions, resultArray, schedules } = this.state;
    const allLocal = localStorage.getItem('localData')
    const localization = JSON.parse(allLocal);
    const hasAcceptedOffer = addListings.some(addListing => addListing.anyAcceptedOffer);
    const hasBuyerType = clietDetail.clientTypes && clietDetail.clientTypes.some((type) => type.clientTypeCode === 1);
    //
    const existingIds = routeData?.clientPotentialListingsShowingRouteItems?.map(
      (item) => item.clientPotentialListingId
    ) || [];

    const filteredAddListings = addListings?.filter(
      (listing) => !existingIds.includes(listing.id)
    );
    const imageUrls = imagesData?.map((img) => img.clientPotentialListingImageLink);

    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}
        <ToastContainer autoClose={2000} />
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteAddListing}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />

        <div className="page-content project-page-content">
          <MetaTags>
            <title>Client Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
            {hasBuyerType ? (
              <Row>
                <Col sm='2' className="pe-0">
                  <ClientSidebar id={this.props.match.params.id} clientId={this.props.match.params.clientId} clientDetail={clietDetail} isResponsive={isResponsive} />
                </Col>
                <Col sm='10' className="">
                  <Row className="project-header">
                    <Col sm="7">
                      <ClientBuyerBreadcrumbs
                        title={this.props.t("Clients")}
                        breadcrumbItem={this.props.t(" Showing")}
                      />
                    </Col>
                    <Col sm="4" className="">
                      <h2 className="">{this.props.t(clietDetail.firstName + " " + clietDetail.lastName)}</h2>
                    </Col>
                  </Row>
                  <ClientBuyerMenu isResponsive={isResponsive} />
                  <Row>


                    <Col xl="12">
                      <Formik
                        enableReinitialize={true}
                        initialValues={{
                          createClientPotentialListingLists: [
                            {
                              clientId: parseInt(this.props.match.params.id),
                              agentId: parseInt(localStorage.getItem('userId')),
                              engagementId: '',
                              mlsId: "",
                              mlsurl: "",
                              listingDate: new Date(),
                              isInterested: true,
                              isActive: true,
                              addedBy: 'agent',
                              listingAddress: '',
                              listingType: '',
                              listedPrice: "",
                              listingCity: "",
                              notes: "",
                              listingBedroom: "",
                              listingBathroom: "",
                              listingParking: "",
                              listingSqFt: "",
                              buyerType: 2
                            }
                          ]
                        }}
                        validationSchema={Yup.object().shape({
                          createClientPotentialListingLists: Yup.array().of(
                            Yup.object().shape({
                              mlsId: Yup.string().required("This is Required"),
                              mlsurl: Yup.string()
                                .notRequired() // optional field
                                .url("Please enter a valid URL"),
                              engagementId: Yup.string().required("This is Required"),
                              listedPrice: Yup.number()
                                .typeError("Invalid Price")
                                .positive("Price must be greater than 0")
                                .required("This is Required"),

                              listingAddress: Yup.string().required("This is Required"),
                              listingBathroom: Yup.number().typeError('Invalid Number'),
                              listingBedroom: Yup.string().typeError('This is Required'),
                              listingParking: Yup.number().typeError('Invalid Number'),
                              listingCity: Yup.string().required("This is Required"),
                              listingType: Yup.string(),
                              listingSqFt: Yup.number().typeError('Invalid Number'),
                            })
                          )
                        })}
                        onSubmit={this.handleAddListingSubmit}
                      >
                        {({ values, errors, touched, handleChange, setFieldValue, setFieldTouched }) => (
                          <Form className="needs-validation">
                            <Card className="border-full">
                              <CardBody>
                                <div className="mt-0 card-title pheading">Add Listing</div>
                                <FieldArray name="createClientPotentialListingLists">
                                  {({ insert, remove, push }) => (
                                    <div>
                                      {values.createClientPotentialListingLists.map((listing, index) => (
                                        <Row key={index}>

                                          <Col sm="2">
                                            {/* <EngagementListBuyerClient 
                                             name={`createClientPotentialListingLists.${index}.engagementId`}
                                              value={listing.engagementId}
                                              onChange={(val) => {
                                                  
                                                  setFieldValue(`createClientPotentialListingLists.${index}.engagementId`, val.id || val);

                                                
                                                   setFieldValue(`createClientPotentialListingLists.${index}.buyerType`, val.buyerType || "");
                                                }}
                                              clientId={this.props.match.params.id} 
                                              agentId={localStorage.getItem('userId')}
                                              typeId={1}
                                              statusId={0}
                                            /> */}
                                            <EngagementListBuyerClient
                                              name={`createClientPotentialListingLists.${index}.engagementId`}
                                              setFieldValue={setFieldValue}
                                              values={values}
                                              clientId={this.props.match.params.id}
                                              agentId={localStorage.getItem("userId")}
                                              typeId={1}
                                              statusId={0}
                                            />


                                          </Col>
                                          <Col sm="2">
                                            <FormGroup>
                                              <Label>Enter MLS or set your own ID*</Label>
                                              <SafeField
                                                name={`createClientPotentialListingLists.${index}.mlsId`}
                                                className={`form-control${errors.createClientPotentialListingLists?.[index]?.mlsId && touched.createClientPotentialListingLists?.[index]?.mlsId ? " is-invalid" : ""}`}
                                              />
                                              <ErrorMessage name={`createClientPotentialListingLists.${index}.mlsId`} component="div" className="invalid-feedback" />
                                            </FormGroup>
                                          </Col>

                                          {/* Address */}
                                          <Col sm="3">
                                            <FormGroup>
                                              <Label>Address *</Label>
                                              <PlacesAutocomplete
                                                value={values.createClientPotentialListingLists[index].listingAddress}
                                                onChange={(value) => setFieldValue(`createClientPotentialListingLists.${index}.listingAddress`, value)}
                                                onSelect={(value) => this.handlePlaceSelected(value, index, setFieldValue)}
                                              >
                                                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                  <div>
                                                    <input
                                                      {...getInputProps({
                                                        name: `createClientPotentialListingLists.${index}.listingAddress`,
                                                        placeholder: "Enter Address...",
                                                        className: `form-control ${errors.createClientPotentialListingLists?.[index]?.listingAddress &&
                                                            touched.createClientPotentialListingLists?.[index]?.listingAddress
                                                            ? "is-invalid"
                                                            : ""
                                                          }`,
                                                        onBlur: () => setFieldTouched(`createClientPotentialListingLists.${index}.listingAddress`, true), // ✅ force Formik touched
                                                      })}
                                                    />
                                                    <div>
                                                      {loading && <div>Loading...</div>}
                                                      {suggestions.map((suggestion, i) => {
                                                        const style = {
                                                          backgroundColor: suggestion.active ? '#007BFF' : '#fff',
                                                          color: suggestion.active ? '#fff' : '#000',
                                                          padding: '10px',
                                                          cursor: 'pointer',
                                                        };
                                                        return (
                                                          <div key={i} {...getSuggestionItemProps(suggestion, { style })}>
                                                            {suggestion.description}
                                                          </div>
                                                        );
                                                      })}
                                                    </div>
                                                  </div>
                                                )}
                                              </PlacesAutocomplete>
                                              {errors.createClientPotentialListingLists?.[index]?.listingAddress &&
                                                touched.createClientPotentialListingLists?.[index]?.listingAddress ? (
                                                <div className="invalid-feedback d-block">
                                                  {errors.createClientPotentialListingLists[index].listingAddress}
                                                </div>
                                              ) : null}
                                            </FormGroup>
                                          </Col>

                                          {/* Public Link */}
                                          <Col sm="3">
                                            <FormGroup>
                                              <Label>Public Link</Label>
                                              <SafeField
                                                name={`createClientPotentialListingLists.${index}.mlsurl`}
                                                className={`form-control${errors.createClientPotentialListingLists?.[index]?.mlsurl && touched.createClientPotentialListingLists?.[index]?.mlsurl ? " is-invalid" : ""}`}
                                              />
                                              <ErrorMessage name={`createClientPotentialListingLists.${index}.mlsurl`} component="div" className="invalid-feedback" />
                                            </FormGroup>
                                          </Col>

                                          {/* Listed Price */}
                                          <Col sm="2">
                                            <FormGroup>
                                              <Label>
                                                {values.createClientPotentialListingLists[index].buyerType === 1
                                                  ? "Monthly Rent*"
                                                  : "Listed Price*"}
                                              </Label>
                                              {/* <CurrencyInput
                                                id={`createClientPotentialListingLists.${index}.listedPrice`}
                                                name={`createClientPotentialListingLists.${index}.listedPrice`}
                                                className="form-control"
                                                prefix={userdetail?.agentDefaultCurrencyCode + " " || '$'}
                                               value={values.createClientPotentialListingLists[index].listedPrice || ""}
                                                decimalsLimit={2}
                                                onValueChange={(value) => {
                                                  setFieldValue(`createClientPotentialListingLists.${index}.listedPrice`, value);
                                                }}
                                              /> */}
                                              <SafeField name={`createClientPotentialListingLists.${index}.listedPrice`}>
                                                {({ field, form }) => (
                                                  <div>
                                                    <CurrencyInput
                                                      id={field.name}
                                                      name={field.name}
                                                      className={`form-control${form.errors.createClientPotentialListingLists?.[index]?.listedPrice &&
                                                          form.touched.createClientPotentialListingLists?.[index]?.listedPrice
                                                          ? " is-invalid"
                                                          : ""
                                                        }`}
                                                      prefix={userdetail?.agentDefaultCurrencyCode + " " || "$"}
                                                      value={field.value || ""}
                                                      decimalsLimit={2}
                                                      onValueChange={(val) => {
                                                        form.setFieldValue(field.name, val);
                                                      }}
                                                      onBlur={() => form.setFieldTouched(field.name, true)}
                                                    />
                                                    <ErrorMessage
                                                      name={`createClientPotentialListingLists.${index}.listedPrice`}
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </div>
                                                )}
                                              </SafeField>
                                              <ErrorMessage name={`createClientPotentialListingLists.${index}.listedPrice`} component="div" className="invalid-feedback" />
                                            </FormGroup>
                                          </Col>

                                          {/* City */}
                                          <Col sm="2">
                                            <FormGroup>
                                              <Label>City *</Label>
                                              <SafeField
                                                name={`createClientPotentialListingLists.${index}.listingCity`}
                                                className={`form-control${errors.createClientPotentialListingLists?.[index]?.listingCity && touched.createClientPotentialListingLists?.[index]?.listingCity ? " is-invalid" : ""}`}
                                              />
                                              <ErrorMessage name={`createClientPotentialListingLists.${index}.listingCity`} component="div" className="invalid-feedback" />
                                            </FormGroup>
                                          </Col>

                                          {/* Type */}
                                          <Col sm="2">
                                            <FormGroup>
                                              <Label>Type</Label>
                                              <SafeField as="select" name={`createClientPotentialListingLists.${index}.listingType`} className="form-control">
                                                <option value="">Select</option>
                                                {map(listingtypes, (listingtype, classkey) => (
                                                  <option key={classkey} value={listingtype.id}>{listingtype.listingTypeTitle}</option>
                                                ))}
                                              </SafeField>
                                            </FormGroup>
                                          </Col>

                                          {/* Bedroom */}
                                          <Col sm="1">
                                            <FormGroup>
                                              <Label>Bedroom</Label>
                                              <SafeField
                                                name={`createClientPotentialListingLists.${index}.listingBedroom`}
                                                className={`form-control${errors.createClientPotentialListingLists?.[index]?.listingBedroom && touched.createClientPotentialListingLists?.[index]?.listingBedroom ? " is-invalid" : ""}`}
                                              />
                                            </FormGroup>
                                          </Col>

                                          {/* Bathroom */}
                                          <Col sm="1">
                                            <FormGroup>
                                              <Label>Bathroom</Label>
                                              <SafeField
                                                name={`createClientPotentialListingLists.${index}.listingBathroom`}
                                                className={`form-control${errors.createClientPotentialListingLists?.[index]?.listingBathroom && touched.createClientPotentialListingLists?.[index]?.listingBathroom ? " is-invalid" : ""}`}
                                              />
                                            </FormGroup>
                                          </Col>

                                          {/* Parking */}
                                          <Col sm="1">
                                            <FormGroup>
                                              <Label>Parking</Label>
                                              <SafeField
                                                name={`createClientPotentialListingLists.${index}.listingParking`}
                                                className={`form-control${errors.createClientPotentialListingLists?.[index]?.listingParking && touched.createClientPotentialListingLists?.[index]?.listingParking ? " is-invalid" : ""}`}
                                              />
                                            </FormGroup>
                                          </Col>

                                          {/* Sq. Ft */}
                                          <Col sm="1">
                                            <FormGroup>
                                              <Label>Sq. Ft</Label>
                                              <SafeField
                                                name={`createClientPotentialListingLists.${index}.listingSqFt`}
                                                className="form-control"
                                              />
                                            </FormGroup>
                                          </Col>

                                          {/* Notes */}
                                          <Col sm="2">
                                            <FormGroup>
                                              <Label>Notes</Label>
                                              <SafeField
                                                name={`createClientPotentialListingLists.${index}.notes`}
                                                className="form-control"
                                              />
                                            </FormGroup>
                                          </Col>

                                          {/* Add/Remove Button */}
                                          {!isResponsive && (
                                            <Col sm="2">
                                              {index === 0 ? (
                                                <Button
                                                  type="button"
                                                  className="btn btn-primary"
                                                  style={{ marginTop: 34 }}
                                                  onClick={() =>
                                                    push({
                                                      clientId: parseInt(this.props.match.params.id),
                                                      agentId: parseInt(localStorage.getItem('userId')),
                                                      engagementId: "",
                                                      mlsId: "",
                                                      mlsurl: "",
                                                      listingAddress: "",
                                                      listedPrice: "",
                                                      listingType: "",
                                                      listingCity: "",
                                                      notes: "",
                                                      listingBedroom: "",
                                                      listingBathroom: "",
                                                      listingParking: "",
                                                      listingSqFt: "",
                                                      listingDate: new Date(),
                                                      isInterested: false,
                                                      isActive: true,
                                                      addedBy: 'agent',
                                                    })
                                                  }
                                                >
                                                  <i className="bx bx-plus-medical" />
                                                </Button>
                                              ) : (
                                                <>
                                                  <Button
                                                    type="button"
                                                    className="btn btn-danger"
                                                    style={{ marginTop: 34 }}
                                                    onClick={() => remove(index)}
                                                  >
                                                    <i className="bx bx-trash" />
                                                  </Button>

                                                  <Button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    style={{ marginTop: 34 }}
                                                    onClick={() =>
                                                      push({
                                                        clientId: parseInt(this.props.match.params.id),
                                                        agentId: parseInt(localStorage.getItem('userId')),
                                                        engagementId: "",
                                                        mlsId: "",
                                                        mlsurl: "",
                                                        listingAddress: "",
                                                        listedPrice: "",
                                                        listingType: "",
                                                        listingCity: "",
                                                        notes: "",
                                                        listingBedroom: "",
                                                        listingBathroom: "",
                                                        listingParking: "",
                                                        listingSqFt: "",
                                                        listingDate: new Date(),
                                                        isInterested: false,
                                                        isActive: true,
                                                        addedBy: 'agent',
                                                      })
                                                    }
                                                  >
                                                    <i className="bx bx-plus-medical" />

                                                  </Button>
                                                </>
                                              )}
                                            </Col>
                                          )}

                                        </Row>
                                      ))}
                                    </div>
                                  )}
                                </FieldArray>

                                {hasPermission("RealtorClientBuyerShowings", "Add") && ( <SaveButton />  )}
                              </CardBody>
                            </Card>
                          </Form>
                        )}
                      </Formik>

                      <Row>
                        <Col sm="12">
                          <Card className="border-full mt-4">
                            <CardHeader>
                              <div className="row">

                                <div className="col-sm-4" style={{ width: 293 }}>
                                  <div className="btn-group rl-group-btn" role="group">
                                    <Link to="#" onClick={this.toggleCreateRoute}>
                                      <button
                                        type="button"
                                        className={`btn btn-outline-secondary w-xs bt-filter-v2`}
                                      >
                                        <span className="d-flex align-items-center gap-2">

                                          <span>Route plans</span>

                                          <img src={routeImg} alt="Grid" style={{ height: 16 }} />
                                        </span>
                                      </button>
                                    </Link>


                                    <Link to="#" onClick={this.canavasbuyeractivity}>
                                      <button
                                        type="button"
                                        className={`btn btn-outline-secondary w-xs bt-filter-v2`}
                                      >
                                        <span className="d-flex align-items-center gap-2">

                                          <span>Buyer Activity</span>

                                          <img src={activityIcon} alt="Grid" style={{ height: 16 }} />
                                        </span>
                                      </button>
                                    </Link>






                                  </div>

                                </div>
                                {isResponsive && (
                                  <Col sm="2"></Col>
                                )}
                                <Col className={isResponsive ? '' : 'p-0'} sm="2" style={isResponsive ? {} : { width: 75 }}>
                                  <label className="fom-label font-size-14" style={{ marginTop: 8, color: '#000' }}>Select Deal</label>
                                </Col>

                                <Col sm="2">
                                  <FilterBuyerDeal
                                    clientId={this.props.match.params.id}
                                    onChange={(dealId) => {
                                      this.setState((prevState) => ({
                                        selectedDeal: dealId,
                                        filters: {
                                          ...prevState.filters,
                                          engagementId: { value: dealId, matchMode: "equals" } 
                                        }
                                      }));
                                    }}
                                  />
                                </Col>
                                 <Col className={isResponsive ? '' : 'p-0'} sm="2" style={isResponsive ? {} : { width: 100, textAlign:'right' }}>
                                  <label className="fom-label font-size-14" style={{ marginTop: 8, color: '#000' }}>Show Listings</label>
                                </Col>
                                 <Col sm="2">
                                  <select 
                                    className="form-select select-filter" 
                                    name="filterType"
                                    value={this.state.selectedFilterType || ""}
                                    onChange={this.handleFilterTypeChange}
                                  >
                                    <option value="">All</option>
                                    <option value="byClient">Sent by client</option>
                                     <option value="byAgent">Sent by agent</option>
                                      <option value="intView">Client is interested to view</option>
                                      <option value="intFav">Client favourites</option>
                                 </select>
                                </Col>
                                <Col sm="6"></Col>

                              </div>

                            </CardHeader>
                            <CardBody>

                              <h5 className={`card-title pd-10 w-100 ${isResponsive ? 'card-mb-title' : ''}`}>
                                All Listings
                                <span className="ms-3">
                                  <img src={worksheetSubmittedIcon} alt="status" style={{ height: 16 }} className="me-1" />
                                  <span>{this.props.t(" Client interested to view")}</span>
                                </span>

                                <span className="ms-3">
                                  <img src={heartRedIcon} alt="status" style={{ height: 20 }} className="me-1" />
                                  <span>{this.props.t(" Client favourite")}</span>
                                </span>
                              </h5>
                              {isResponsive ? (
                              <DataTable
                                value={addListings}
                                dataKey="id"
                                responsiveLayout="stack"
                                expandedRows={this.state.expandedRows}
                                onRowToggle={(e) => this.setState({ expandedRows: e.data })}
                                paginator rows={10}
                                globalFilterFields={["engagementId"]}
                                filters={this.state.filters}
                                rowExpansionTemplate={(rowData) => (
                                  <table className="table table-bordered mb-0">
                                    <tbody>
                                      <tr><th>City</th><td>{rowData.listingCity}</td></tr>
                                      <tr><th>City</th><td>{this.getStatus(rowData.listingStatusId) || "N/A"}</td></tr>
                                      <tr><th>Showing</th>
                                        <td>
                                          {rowData.showingDate ? (
                                            <>
                                              <Moment format="MMM DD">{rowData.showingDate}</Moment> / {rowData.startTime || "N/A"}
                                            </>
                                          ) : (
                                            "N/A"
                                          )}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th></th>
                                        <td>

                                          <Link to="#" className="header-item noti-icon-mesaage me-3">
                                            <img src={messageIcon} style={{ width: 32 }} alt="" />
                                            <span className="badge bg-blue bg-danger rounded-pill">{rowData.newMessageCount}</span>
                                          </Link>{" "}
                                          <Link
                                            to="#"
                                            className="btn btn-action"
                                            onClick={() => this.toggleRightCanvas(rowData)}
                                          >
                                            Manage
                                          </Link>{" "}
                                          {rowData.listingStatusId === 1 ? (
                                            (!rowData.anyAcceptedOffer ||
                                              (rowData.anyAcceptedOffer &&
                                                ["Offer Accepted", "Offer Submitted"].includes(
                                                  rowData.transactionStatus?.title
                                                ))) ? (
                                              <Link
                                                to="#"
                                                className="btn btn-green"
                                                onClick={() => this.toggleOfferAccepted(rowData)}
                                              >
                                                {row.transactionStatus?.title || "Offer"}
                                              </Link>
                                            ) : (
                                              <button className="btn btn-green-disabled" disabled>
                                                Active deal exists
                                              </button>
                                            )
                                          ) : (
                                            <button className="btn btn-green-disabled" disabled>Property not available </button>
                                          )}
                                          {rowData.IsListingDeleteAllowed == true && (
                                            <ActionDelete onClick={() => this.onClickDelete(row)} />
                                          )}

                                        </td>
                                      </tr>

                                    </tbody>
                                  </table>
                                )}
                              >
                                <Column expander style={{ width: '3em' }} />
                                 <Column
                                    header="#"
                                    body={(rowData, options) => options.rowIndex + 1}
                                    style={{ width: '60px' }}
                                  />
                                <Column field="listingDate" header="Date" body={this.dateTemplate} />
                                <Column field="mlsId" header="Id" body={this.idTemplate}

                                />
                                <Column field="listedPrice" header="Price" dataType="numeric" body={this.priceTemplate}

                                />



                              </DataTable>
                              ):(
                                  <DataTable
                                value={addListings}
                                paginator
                                rows={10}
                                ref={this.dt}
                                sortMode="multiple"
                                removableSort
                                emptyMessage="No listings found."
                                globalFilterFields={["engagementId"]}
                                filters={this.state.filters}
                              >
                                 <Column
                                    header="#"
                                    body={(rowData, options) => options.rowIndex + 1}
                                    style={{ width: '60px' }}
                                  />
                                <Column field="listingDate" header="Date" body={this.dateTemplate} />
                                <Column field="mlsId" header="Id" body={this.idTemplate}
                                  filter
                                  showFilterMatchModes={false}
                                  showFilterOperator={false}
                                  showAddButton={false}
                                  showClearButton={false}
                                />
                                <Column field="listedPrice" header="Price" dataType="numeric" body={this.priceTemplate}
                                  filter
                                  showFilterOperator={false}
                                  showAddButton={false}
                                />
                                <Column field="listingCity" header="City"
                                  filter
                                  showFilterMatchModes={false}
                                  showFilterOperator={false}
                                  showAddButton={false}
                                  showClearButton={false}
                                  filterMatchMode="in"
                                  filterElement={this.cityFilterTemplate}
                                />
                                <Column
                                  field="listingStatusId"
                                  header="Status"
                                  body={(row) => this.getStatus(row.listingStatusId) || "N/A"}
                                  filter
                                  showFilterMatchModes={false}
                                  showFilterOperator={false}
                                  showAddButton={false}
                                  showClearButton={false}
                                  filterMatchMode="in"
                                  filterElement={this.statusFilterTemplate}
                                />

                                <Column field="showingDate" header="Showing" body={this.showingTemplate} />
                                <Column
                                  headerClassName="action-header"
                                  header={
                                    <div className="justify-content-end">
                                      <RsLink
                                        onClick={() => this.dt.current.reset()}
                                        iconClass="bx bx-reset"
                                        className="btn-light"
                                      >
                                        Reset all filters
                                      </RsLink>
                                    </div>
                                  }
                                  body={this.actionTemplate} />
                              </DataTable>
                              )}
                            
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </Col>

                  </Row>
                </Col>
              </Row>
            ) : (
              <NoAccess />

            )}
          </Container>
        </div>

        <Offcanvas
          isOpen={this.state.isRight}
          direction="end"
          toggle={this.toggleRightCanvas}
          style={{ width: 800 }}
        >
          <OffcanvasHeader toggle={this.toggleRightCanvas}>
            Manage Listing
          </OffcanvasHeader>
          <OffcanvasBody>
            <Nav pills className="navtab-bg nav-justified">
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab1 === "1",
                  })}
                  onClick={() => {
                    this.toggle1("1");
                  }}
                >
                  Detail
                </NavLink>
              </NavItem>
              {userdetail?.agentTimeZone?.isTwilioIntegrationEnabled && (
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: this.state.activeTab1 === "2",
                    })}
                    onClick={() => {
                      this.toggle1("2");
                    }}
                  >
                    Message
                  </NavLink>
                </NavItem>
              )}
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab1 === "4",
                  })}
                  onClick={() => {

                    this.toggle1("4");
                    this.postActivity();
                  }}
                >
                  Schedule
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab1 === "3",
                  })}
                  onClick={() => {
                    this.toggle1("3");
                  }}
                >
                  Images
                </NavLink>
              </NavItem>

            </Nav>
            <TabContent
              activeTab={this.state.activeTab1}
              className="p-3 text-muted"
            >
              <TabPane tabId="1">
                <div className="tabContent">
                  <Formik
                    enableReinitialize={true}
                    initialValues={{
                      id: addListing.id,
                      clientPotentialListingId: addListing.clientPotentialListingId,
                      clientId: addListing.clientId,
                      agentId: addListing.agentId,
                      mlsId: addListing.mlsId,
                      mlsurl: addListing.mlsurl,
                      listingDate: addListing.listingDate,
                      engagementId: addListing.engagementId,
                      listingStatusId: addListing.listingStatusId,
                      isInterested: addListing.isInterested,
                      isActive: addListing.isActive,
                      addedBy: addListing.addedBy,
                      listedPrice: addListing.listedPrice,
                      listingType: addListing.listingType,
                      listingBedroom: addListing.listingBedroom,
                      listingBathroom: addListing.listingBathroom,
                      listingParking: addListing.listingParking,
                      listingSqFt: addListing.listingSqFt,
                      listingAddress: addListing.listingAddress,
                      listingCity: addListing.listingCity,
                      notes: addListing.notes,
                      showingDate: addListing.showingDate,
                      startTime: addListing.startTime,
                      endTime: addListing.endTime,
                      showingStatus: addListing.showingStatus,
                      showingStatusId: addListing.showingStatusId,
                      clientNotes: addListing.clientNotes,
                      likeDislike: addListing.likeDislike,
                      statusId: addListing.statusId,
                      feedback: addListing.feedback,
                      transactionStatus: addListing.transactionStatus
                    }}
                    validationSchema={Yup.object().shape({

                      mlsId: Yup.string().required("This is Required"),
                      listedPrice: Yup.string().required("This is Required"),
                      //mlsurl: Yup.string().url("Enter a valid URL").nullable(), 

                      //listingBathroom: Yup.number().typeError('Invalid Number'),
                      //listingBedroom: Yup.number().typeError('Invalid Number'),
                      //listingParking: Yup.number().typeError('Invalid Number'),
                      listingCity: Yup.string().required("This is Required"),

                    })}

                    onSubmit={values => {
                      if (isEdit) {
                        const updateAddListing = {
                          id: values.id,
                          clientPotentialListingId: values.clientPotentialListingId,
                          clientId: parseInt(values.clientId),
                          agentId: parseInt(values.agentId),
                          mlsId: values.mlsId,
                          mlsurl: values.mlsurl,
                          listingDate: values.listingDate,
                          listingStatusId: parseInt(values.listingStatusId),
                          isInterested: values.isInterested,
                          engagementId: values.engagementId,
                          isActive: values.isActive,
                          addedBy: values.addedBy,
                          listedPrice: parseInt(values.listedPrice),
                          listingType: parseInt(values.listingType),
                          listingBedroom: values.listingBedroom,
                          listingBathroom: values.listingBathroom,
                          listingParking: parseInt(values.listingParking),
                          listingSqFt: values.listingSqFt,
                          listingAddress: values.listingAddress,
                          listingCity: values.listingCity,
                          notes: values.notes,
                          showingDate: values.showingDate,
                          startTime: values.startTime,
                          endTime: values.endTime,
                          showingStatus: addListing.showingStatus,
                          showingStatusId: parseInt(addListing.showingStatusId),
                          clientNotes: values.clientNotes,
                          likeDislike: values.likeDislike,
                          //statusId: parseInt(values.statusId),
                          feedback: values.feedback
                        };

                        onUpdateClientAddListing(updateAddListing, (status) => {
                          if (status === true) {
                            this.toggleRight();
                          }
                        });

                      } else {

                      }

                    }}

                  >
                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                      <Form
                        className="needs-validation"
                      >
                        {isResponsive ? (
                           <Row>
                          <Col sm="12">
                            <div className="d-flex align-items-center gap-3 box-brd">

                              <div className="font-size-12"><strong>Address :</strong> <br/>{addListing.listingAddress}</div>
                              <div className="font-size-12"><strong>

                                Client interest:</strong>  <br/>{addListing.isInterested ? (
                                  <img src={worksheetSubmittedIcon} width="16px" className="ms-2" />
                                ) : (
                                  <img src={crossIcon} width="16px" className="ms-2" />
                                )}
                              </div>

                              <div className="font-size-12"><strong>
                                Status:{" "}

                              </strong><br/>
                                {addListing.listingStatusId
                                  ? this.getStatus(addListing.listingStatusId)
                                  : ""}
                              </div>
                            </div>

                          </Col>

                        </Row>
                        ):(
                           <Row>
                          <Col sm="12">
                            <div className="d-flex align-items-center gap-3 box-brd">

                              <div className="font-size-12"><strong>Address :</strong> {addListing.listingAddress}</div>
                              <div className="font-size-12"><strong>

                                Client interest:</strong>  {addListing.isInterested ? (
                                  <img src={worksheetSubmittedIcon} width="16px" className="ms-2" />
                                ) : (
                                  <img src={crossIcon} width="16px" className="ms-2" />
                                )}
                              </div>

                              <div className="font-size-12"><strong>
                                Status:{" "}

                              </strong>
                                {addListing.listingStatusId
                                  ? this.getStatus(addListing.listingStatusId)
                                  : ""}
                              </div>
                            </div>

                          </Col>

                        </Row>
                        )}
                       
                        <Row>

                          <Col sm="3">
                            <FormGroup className="mb-3">
                              <Label htmlFor="statusId">
                                {this.props.t("Status")}
                              </Label>
                              <SafeField as="select" name="listingStatusId"
                                className={
                                  "form-control" +
                                  (errors.listingStatusId && touched.listingStatusId
                                    ? " is-invalid"
                                    : "")
                                }

                                onChange={handleChange}>
                                <option value="">Select</option>
                                <option value="1">Available </option>
                                <option value="2">Not Available</option>
                                <option value="3">Sold</option>
                                <option value="4">Sold Conditionally</option>

                              </SafeField>
                              <ErrorMessage
                                name="listingType"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>

                          <Col sm="3">
                            <FormGroup className="mb-3">
                              <Label htmlFor="mlsId">
                                {this.props.t("Unit ID# *")}
                              </Label>
                              <SafeField
                                name="mlsId"
                                onChange={handleChange}
                                type="text"

                                className={
                                  "form-control" +
                                  (errors.mlsId && touched.mlsId
                                    ? " is-invalid"
                                    : "")
                                }

                                id="mlsId"
                              />
                              <ErrorMessage
                                name="mlsId"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>
                          <Col sm="3">
                            <FormGroup className="mb-3">
                              <Label htmlFor="listedPrice">
                                {this.props.t("Listed Price*")}
                              </Label>
                              <CurrencyInput
                                name="listedPrice"
                                value={values.listedPrice}
                                className="form-control"
                                onValueChange={(value) => setFieldValue('listedPrice', value)}
                                prefix={userdetail.agentDefaultCurrencyCode + " "}
                                decimalsLimit={2}

                              />
                              {/* <SafeField
                                name="listedPrice"
                                onChange={handleChange}
                                type="text"

                                className={
                                  "form-control" +
                                  (errors.listedPrice && touched.listedPrice
                                    ? " is-invalid"
                                    : "")
                                }

                                id="listedPrice"
                              /> */}
                              <ErrorMessage
                                name="listedPrice"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>

                          </Col>

                          <Col sm="3">
                            <FormGroup className="mb-3">
                              <Label htmlFor="listingCity">
                                {this.props.t("City *")}
                              </Label>
                              <SafeField
                                name="listingCity"
                                onChange={handleChange}
                                type="text"

                                className={
                                  "form-control" +
                                  (errors.listingCity && touched.listingCity
                                    ? " is-invalid"
                                    : "")
                                }

                                id="listingCity"
                              />
                              <ErrorMessage
                                name="listingCity"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>

                          </Col>
                          <Col sm="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="listingAddress *">
                                {this.props.t("Address")}
                              </Label>
                              <PlacesAutocomplete
                                value={values.listingAddress}
                                onChange={(value) => setFieldValue('listingAddress', value)}
                                onSelect={(value) => this.handleEditPlaceSelected(value, setFieldValue)}
                              >
                                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                  <div>
                                    <input
                                      {...getInputProps({
                                        placeholder: 'Enter Address...',
                                        className: 'form-control',

                                      })}
                                    />
                                    <div className="">
                                      {loading ? <div>Loading...</div> : null}

                                      {suggestions.map((suggestion, i) => {
                                        const className = suggestion.active
                                          ? 'suggestion-item--active'
                                          : 'suggestion-item';
                                        const style = suggestion.active
                                          ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                          : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                                        return (
                                          <div
                                            key={i}
                                            {...getSuggestionItemProps(suggestion, {
                                              style,
                                            })}
                                          >
                                            {suggestion.description}
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
                                )}
                              </PlacesAutocomplete>
                              <ErrorMessage
                                name="address"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>
                          <Col sm="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="mlsurl">
                                {this.props.t("Public Link")} {values.mlsurl ? <a href={values.mlsurl} target="_blank" rel="noreferrer"><i className="bx bx-link-external"></i></a> : ''}
                              </Label>
                              <SafeField
                                name="mlsurl"
                                onChange={handleChange}
                                type="text"

                                className={
                                  "form-control" +
                                  (errors.mlsId && touched.mlsurl
                                    ? " is-invalid"
                                    : "")
                                }

                                id="mlsurl"
                              />
                              <ErrorMessage
                                name="mlsurl"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>

                          <Col sm="4">
                            <FormGroup className="mb-3">
                              <Label htmlFor="listingType">
                                {this.props.t("Type")}
                              </Label>
                              <SafeField as="select" name="listingType"
                                className={
                                  "form-control" +
                                  (errors.listingType && touched.listingType
                                    ? " is-invalid"
                                    : "")
                                }

                                onChange={handleChange}>
                                <option value="">Select</option>
                                {map(listingtypes, (listingtype, classkey) => (
                                  <option key={classkey} value={listingtype.id}>{listingtype.listingTypeTitle}</option>
                                ))}
                              </SafeField>
                              <ErrorMessage
                                name="listingType"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>
                          <Col sm="2">
                            <FormGroup className="mb-3">
                              <Label htmlFor="listingBedroom">
                                {this.props.t("Bedroom")}
                              </Label>
                              <SafeField
                                name="listingBedroom"
                                onChange={handleChange}
                                type="text"

                                className={
                                  "form-control" +
                                  (errors.listingBedroom && touched.listingBedroom
                                    ? " is-invalid"
                                    : "")
                                }

                                id="listingBedroom"
                              />
                              <ErrorMessage
                                name="listingBedroom"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>

                          </Col>
                          <Col sm="2">
                            <FormGroup className="mb-3">
                              <Label htmlFor="listingBathroom">
                                {this.props.t("Bathroom")}
                              </Label>
                              <SafeField
                                name="listingBathroom"
                                onChange={handleChange}
                                type="text"

                                className={
                                  "form-control" +
                                  (errors.listingBathroom && touched.listingBathroom
                                    ? " is-invalid"
                                    : "")
                                }

                                id="listingBathroom"
                              />
                              <ErrorMessage
                                name="listingBathroom"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>

                          </Col>
                          <Col sm="2">
                            <FormGroup className="mb-3">
                              <Label htmlFor="listingParking">
                                {this.props.t("Parking")}
                              </Label>
                              <SafeField
                                name="listingParking"
                                onChange={handleChange}
                                type="text"

                                className={
                                  "form-control" +
                                  (errors.listingParking && touched.listingParking
                                    ? " is-invalid"
                                    : "")
                                }

                                id="listingParking"
                              />
                              <ErrorMessage
                                name="listingParking"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>

                          </Col>
                          <Col sm="2">
                            <FormGroup className="mb-3">
                              <Label htmlFor="listingSqFt">
                                {this.props.t("Sq. Ft")}
                              </Label>
                              <SafeField
                                name="listingSqFt"
                                onChange={handleChange}
                                type="text"

                                className={
                                  "form-control" +
                                  (errors.listingSqFt && touched.listingSqFt
                                    ? " is-invalid"
                                    : "")
                                }

                                id="listingSqFt"
                              />
                              <ErrorMessage
                                name="listingSqFt"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>

                          </Col>
                          <Col sm="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="notes">
                                {this.props.t("Notes")}
                              </Label>
                              <SafeField
                                name="notes"
                                onChange={handleChange}
                                as="textarea"
                                style={{ minHeight: 70 }}
                                className={
                                  "form-control" +
                                  (errors.notes && touched.notes
                                    ? " is-invalid"
                                    : "")
                                }

                                id="notes"
                              />
                              <ErrorMessage
                                name="notes"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>

                          </Col>

                        </Row>
                        <Row>

                          <div className="clearFix">
                            <UpdateButton>{this.props.t("Update")}</UpdateButton> {" "} <RsLink onClick={this.toggleRightCanvas}>Cancel</RsLink> {" "}

                            {/* {values.transactionStatus == null ?
                              <RsLink className="btn btn-del-outline" iconClass="bx bx-trash" onClick={() => this.onClickDelete(addListing)}>Delete</RsLink>
                              : " "} */}

                          </div>

                        </Row>
                      </Form>
                    )}
                  </Formik>
                </div>
              </TabPane>
              {userdetail?.agentTimeZone?.isTwilioIntegrationEnabled && (
                <TabPane tabId="2">
                  <div className="tabContent">
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        clientPotentialListingMessageBy: userdetail?.firstName,
                        clientPotentialListingId: addListing?.id,
                        scheduleDate: new Date(),
                        notes: "",
                      }}
                      validationSchema={Yup.object().shape({

                        notes: Yup.string().required("This is Required"),


                      })}
                      onSubmit={this.handleSubmitMessage}

                    >
                      {({ errors, touched, values, handleChange, setFieldValue }) => (
                        <Form
                          className="needs-validation"
                        >
                             {isResponsive ? (
                           <Row>
                          <Col sm="12">
                            <div className="d-flex align-items-center gap-3 box-brd">

                              <div className="font-size-12"><strong>Address :</strong> <br/>{addListing.listingAddress}</div>
                              <div className="font-size-12"><strong>

                                Client interest:</strong>  <br/>{addListing.isInterested ? (
                                  <img src={worksheetSubmittedIcon} width="16px" className="ms-2" />
                                ) : (
                                  <img src={crossIcon} width="16px" className="ms-2" />
                                )}
                              </div>

                              <div className="font-size-12"><strong>
                                Status:{" "}

                              </strong><br/>
                                {addListing.listingStatusId
                                  ? this.getStatus(addListing.listingStatusId)
                                  : ""}
                              </div>
                            </div>

                          </Col>

                        </Row>
                        ):(
                           <Row>
                          <Col sm="12">
                            <div className="d-flex align-items-center gap-3 box-brd">

                              <div className="font-size-12"><strong>Address :</strong> {addListing.listingAddress}</div>
                              <div className="font-size-12"><strong>

                                Client interest:</strong>  {addListing.isInterested ? (
                                  <img src={worksheetSubmittedIcon} width="16px" className="ms-2" />
                                ) : (
                                  <img src={crossIcon} width="16px" className="ms-2" />
                                )}
                              </div>

                              <div className="font-size-12"><strong>
                                Status:{" "}

                              </strong>
                                {addListing.listingStatusId
                                  ? this.getStatus(addListing.listingStatusId)
                                  : ""}
                              </div>
                            </div>

                          </Col>

                        </Row>
                        )}
                          <Row>


                            <Col sm="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="notes" className="w-100">
                                  {this.props.t("Enter your message *")}
                                  <span className="float-end"> <AiButton onInsert={(text) => this.handleInsertAi(text, setFieldValue)} /> </span>
                                </Label>
                                <SafeField
                                  name="notes"
                                  onChange={handleChange}
                                  as="textarea"

                                  className={
                                    "form-control" +
                                    (errors.notes && touched.notes
                                      ? " is-invalid"
                                      : "")
                                  }

                                  id="mls"
                                />
                                <ErrorMessage
                                  name="notes"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>

                            </Col>

                          </Row>
                          <Row>

                            <div className="clearFix">

                              <button type="submit" className="btn btn-primary w-md" name="addActivity" id="addActivity"> {this.props.t("Send")}</button>{" "}

                            </div>

                          </Row>
                        </Form>
                      )}
                    </Formik>

                    <div style={{ marginTop: 40 }}>
                      <Table className="table table-sm m-0">
                        <ul className="verti-timeline list-unstyled">
                          {messageData?.map((message, index) => (
                            <li className="event-list eventlist" key={`_allact_${index}`}>
                              <div className="event-timeline-dot">

                              </div>
                              <div className="d-flex">

                                <div className="flex-grow-1">
                                  <h5 className="font-size-14">
                                    {message.clientPotentialListingMessageBy || ''} -  <Moment format="MMM Do">{message.scheduleDate}</Moment>
                                  </h5>
                                </div>
                              </div>
                              <div className="exNote">{message.notes}</div>
                            </li>
                          ))}
                        </ul>

                      </Table>
                    </div>
                  </div>
                </TabPane>
              )}
              <TabPane tabId="3">
                <div className="tabContent">
                   {isResponsive ? (
                           <Row>
                          <Col sm="12">
                            <div className="d-flex align-items-center gap-3 box-brd">

                              <div className="font-size-12"><strong>Address :</strong> <br/>{addListing.listingAddress}</div>
                              <div className="font-size-12"><strong>

                                Client interest:</strong>  <br/>{addListing.isInterested ? (
                                  <img src={worksheetSubmittedIcon} width="16px" className="ms-2" />
                                ) : (
                                  <img src={crossIcon} width="16px" className="ms-2" />
                                )}
                              </div>

                              <div className="font-size-12"><strong>
                                Status:{" "}

                              </strong><br/>
                                {addListing.listingStatusId
                                  ? this.getStatus(addListing.listingStatusId)
                                  : ""}
                              </div>
                            </div>

                          </Col>

                        </Row>
                        ):(
                           <Row>
                          <Col sm="12">
                            <div className="d-flex align-items-center gap-3 box-brd">

                              <div className="font-size-12"><strong>Address :</strong> {addListing.listingAddress}</div>
                              <div className="font-size-12"><strong>

                                Client interest:</strong>  {addListing.isInterested ? (
                                  <img src={worksheetSubmittedIcon} width="16px" className="ms-2" />
                                ) : (
                                  <img src={crossIcon} width="16px" className="ms-2" />
                                )}
                              </div>

                              <div className="font-size-12"><strong>
                                Status:{" "}

                              </strong>
                                {addListing.listingStatusId
                                  ? this.getStatus(addListing.listingStatusId)
                                  : ""}
                              </div>
                            </div>

                          </Col>

                        </Row>
                        )}
                  <Dropzone onDrop={this.handleAcceptedFiles}>
                    {({ getRootProps, getInputProps }) => (
                      <div className="dropzone">
                        <div className="dz-message needsclick" {...getRootProps()}>
                          <input {...getInputProps()} />
                          <div className="mb-3">
                            <i className="display-4 text-muted bx bxs-cloud-upload" />
                          </div>
                          <h4>Drop files here or click to upload.</h4>
                          <small className="text-muted font-size-12">{UPLOADTEXT.GIMG}</small>
                        </div>
                      </div>
                    )}
                  </Dropzone>


                  <Row className="mb-3" style={{ marginTop: 20 }}>
                    {imagesData?.map((img, index) => (
                      <Col sm="6" key={index}>
                        <div className="image-thumbnail-wrapper">
                          <img
                            src={img.clientPotentialListingImageLink}
                            className="thumbnail-img"
                            alt={`thumbnail-${index}`}
                            onClick={() => this.handleOpenLightbox(index)}
                            style={{ cursor: "pointer" }}
                          />
                          <button
                            className="delete-btn"
                            onClick={() => this.handleDeleteImage(img.id, index)}
                          >
                            &times;
                          </button>
                        </div>
                      </Col>
                    ))}
                  </Row>

                  {lightboxOpen && (
                    <Lightbox
                      mainSrc={imageUrls[photoIndex]}
                      nextSrc={imageUrls[(photoIndex + 1) % imageUrls.length]}
                      prevSrc={imageUrls[(photoIndex + imageUrls.length - 1) % imageUrls.length]}
                      onCloseRequest={() => this.setState({ lightboxOpen: false })}
                      onMovePrevRequest={() =>
                        this.setState({
                          photoIndex: (photoIndex + imageUrls.length - 1) % imageUrls.length,
                        })
                      }
                      onMoveNextRequest={() =>
                        this.setState({
                          photoIndex: (photoIndex + 1) % imageUrls.length,
                        })
                      }
                    />
                  )}
                </div>
              </TabPane>
              <TabPane tabId="4">
                <div className="tabContent">
                  <Formik
                    enableReinitialize={true}
                    initialValues={{
                      id: addListing?.id,
                      clientPotentialListingId: addListing?.clientPotentialListingId,
                      clientId: this.props.match.params.id,
                      agentId: addListing?.agentId,
                      notes: addListing?.notes,
                      showingDate: null,
                      startTime: '',
                      endTime: '',
                      showingStatus: "Request Re-schedule",
                      showingStatusId: 2,
                      clientNotes: ''

                    }}
                    validationSchema={Yup.object().shape({
                      showingDate: Yup.string()
                        .nullable()
                        .required("This is Required"),
                      startTime: Yup.string()
                        .nullable()
                        .required("This is Required"),
                      endTime: Yup.string()
                        .nullable()
                        .required("This is Required"),
                      //clientNotes: Yup.string().required("This is Required"),
                    })}
                    onSubmit={this.handleSubmitResuchedule}

                  >
                    {({ errors, touched, values, handleChange, setFieldValue, setFieldTouched }) => (
                      <Form
                        className="needs-validation"
                      >
                         {isResponsive ? (
                           <Row>
                          <Col sm="12">
                            <div className="d-flex align-items-center gap-3 box-brd">

                              <div className="font-size-12"><strong>Address :</strong> <br/>{addListing.listingAddress}</div>
                              <div className="font-size-12"><strong>

                                Client interest:</strong>  <br/>{addListing.isInterested ? (
                                  <img src={worksheetSubmittedIcon} width="16px" className="ms-2" />
                                ) : (
                                  <img src={crossIcon} width="16px" className="ms-2" />
                                )}
                              </div>

                              <div className="font-size-12"><strong>
                                Status:{" "}

                              </strong><br/>
                                {addListing.listingStatusId
                                  ? this.getStatus(addListing.listingStatusId)
                                  : ""}
                              </div>
                            </div>

                          </Col>

                        </Row>
                        ):(
                           <Row>
                          <Col sm="12">
                            <div className="d-flex align-items-center gap-3 box-brd">

                              <div className="font-size-12"><strong>Address :</strong> {addListing.listingAddress}</div>
                              <div className="font-size-12"><strong>

                                Client interest:</strong>  {addListing.isInterested ? (
                                  <img src={worksheetSubmittedIcon} width="16px" className="ms-2" />
                                ) : (
                                  <img src={crossIcon} width="16px" className="ms-2" />
                                )}
                              </div>

                              <div className="font-size-12"><strong>
                                Status:{" "}

                              </strong>
                                {addListing.listingStatusId
                                  ? this.getStatus(addListing.listingStatusId)
                                  : ""}
                              </div>
                            </div>

                          </Col>

                        </Row>
                        )}
                        <Row>

                          <Col sm="4">
                            <FormGroup className="mb-3">
                              <Label htmlFor="showingDate">
                                {this.props.t("Schedule Date *")}
                              </Label>
                              <Flatpickr
                                className={
                                  "form-control" +
                                  (errors.showingDate && touched.showingDate
                                    ? " is-invalid"
                                    : "")
                                }
                                placeholder=""
                                value={values.showingDate}
                                onChange={(value) => setFieldValue('showingDate', value[0])}
                                options={{
                                  altInput: true,
                                  //minDate: "today",
                                  altFormat: "F j, Y",
                                  dateFormat: "Y-m-d"
                                }}
                              />

                              <ErrorMessage
                                name="showingDate"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>
                          <Col sm="4">
                            <TimePicker
                              name="startTime"
                              label="Start Time *"
                              value={values.startTime}
                              onChange={(val) => setFieldValue("startTime", val)}
                              onBlur={() => setFieldTouched("startTime", true)}
                              minTime={null}
                              error={errors.startTime}
                              touched={touched.startTime}
                            />

                          </Col>
                          <Col md="4">
                            <TimePicker
                              name="endTime"
                              label="End Time *"
                              value={values.endTime}
                              onChange={(val) => setFieldValue("endTime", val)}
                              onBlur={() => setFieldTouched("endTime", true)}
                              minTime={values.startTime}
                              disabled={!values.startTime}
                              error={errors.endTime}
                              touched={touched.endTime}
                            />
                          </Col>
                          <Col sm="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="clientNotes">
                                {this.props.t("Notes")}
                              </Label>
                              <SafeField
                                name="clientNotes"
                                onChange={handleChange}
                                as="textarea"
                                style={{ minHeight: 70 }}

                                className={
                                  "form-control" +
                                  (errors.clientNotes && touched.clientNotes
                                    ? " is-invalid"
                                    : "")
                                }

                                id="mls"
                              />
                              <ErrorMessage
                                name="clientNotes"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>

                          </Col>

                        </Row>

                        <Row>

                          <div className="clearFix">
                            {addListing.listingStatusId == 1 ?
                              <button type="submit" className="btn btn-primary w-md" name="addActivity" id="addActivity"> {this.props.t("Submit")}</button>
                              : <Alert color="danger">Listing status set to - <strong>Not available</strong></Alert>
                            }
                          </div>

                        </Row>
                        {addListing?.showingDate != null && (
                          <>
                            <Row>
                              <Col sm="12">
                                <h4><strong>Current Showing</strong></h4>
                                <ul className="verti-timeline list-unstyled">
                                  <li className="event-list eventlist">
                                    <div className="">
                                      <div className="flex-shrink-0 me-3">
                                        <h5 className="font-size-14">
                                          Date : <Moment format="D MMM YY">{addListing?.showingDate}</Moment> <span className="float-end"> <ActionDelete onClick={() => this.handleDeleteShowing(addListing)} /> </span>
                                        </h5>
                                      </div>
                                      <div className="flex-grow-1">
                                        <h5 className="font-size-14">
                                          Time : {addListing?.startTime} - {addListing?.endTime}
                                        </h5>
                                      </div>
                                    </div>
                                    <div className="exNote">Notes: {addListing?.notes}</div>
                                  </li>
                                </ul>
                              </Col>
                            </Row>

                            <Row>
                              <Row>
                                <Col sm="12">
                                  <h4><strong>Showing history</strong></h4>
                                  <ul className="verti-timeline list-unstyled">
                                    {Array.isArray(schedules) && schedules.map((schedule, index) => (
                                      <li className="event-list eventlist" key={index}>
                                        <div className="">
                                          <div className="flex-shrink-0 me-3">
                                            <h5 className="font-size-14">
                                              Date : <Moment format="D MMM YY">{schedule.showingDate}</Moment>
                                            </h5>
                                          </div>
                                          <div className="flex-grow-1">
                                            <h5 className="font-size-14">
                                              Time : {schedule.startTime} - {schedule.endTime}
                                            </h5>
                                          </div>
                                        </div>
                                        <div className="exNote">Notes: {schedule.notes}</div>
                                      </li>
                                    ))}
                                  </ul>
                                </Col>
                              </Row>
                            </Row>
                          </>
                        )}

                        {/* <Row className="mt-20">
                            <Col sm="12">
                              <FullCalendar
                                ref={this.calendarRef}
                                plugins={[dayGridPlugin, interactionPlugin, BootstrapTheme]}
                                initialView="dayGridMonth"
                                headerToolbar={{
                                  left: "prev,next today",
                                  center: "title",
                                  right: "dayGridMonth,dayGridWeek,dayGridDay",
                                }}
                                editable={true}
                                droppable={true}
                                selectable={true}
                                height="auto"
                                events={resultArray}
                              
                              />

                            </Col>
                          </Row> */}

                      </Form>
                    )}
                  </Formik>

                </div>
              </TabPane>
            </TabContent>

          </OffcanvasBody>
        </Offcanvas>



        <Offcanvas
          isOpen={this.state.isOffer}
          direction="end"
          toggle={this.toggleOfferAccepted}
          style={{ width: 800 }}
        >
          <OffcanvasHeader toggle={this.toggleOfferAccepted}>
            Set Offer
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
                listingStatusId: addListing.listingStatusId,
                id: (buyeroffer?.id) ? buyeroffer?.id : 0,
                offerId: (buyeroffer?.offerId) ? buyeroffer?.offerId : '',
                agentId: addListing.agentId,
                mlsId: addListing.mlsId,
                clientId: this.props.match.params.id,
                propertyURL: buyeroffer?.propertyURL ? buyeroffer?.propertyURL : addListing.mlsurl,
                propertyType: (buyeroffer?.propertyType) ? buyeroffer?.propertyType : '',
                propertyAddress: (buyeroffer?.propertyAddress) ? buyeroffer?.propertyAddress : addListing.listingAddress,
                transTypeId: 2,
                //commissionTypeId: (buyeroffer?.commissionTypeId) ? buyeroffer?.commissionTypeId : 0,
                //commisisonValue: (buyeroffer?.commisisonValue) ? buyeroffer?.commisisonValue : 0,
                askingPrice: (buyeroffer?.askingPrice) ? buyeroffer?.askingPrice : addListing.listedPrice,
                offerPrice: (buyeroffer?.offerPrice) ? buyeroffer?.offerPrice : null,
                deposit: (buyeroffer?.deposit) ? buyeroffer?.deposit : null,
                offerDate: (buyeroffer?.offerDate) ? buyeroffer?.offerDate : null,
                buyerType: addListing?.buyerType,
                agreementStartDate: (buyeroffer?.agreementStartDate) ? buyeroffer?.agreementStartDate : null,
                agreementEndDate: (buyeroffer?.agreementEndDate) ? buyeroffer?.agreementEndDate : null,
                closingDate: (buyeroffer?.closingDate) ? buyeroffer?.closingDate : null,
                expiryDate: (buyeroffer?.expiryDate) ? buyeroffer?.expiryDate : null,
                expiryTime: buyeroffer?.expiryTime,
                refId: addListing.id,
                refTypeId: 0,
                statusId: (buyeroffer?.statusId) ? buyeroffer?.statusId : '',
                isAccepted: '',
                conditions: '',
                notes: (buyeroffer?.notes) ? buyeroffer?.notes : '',
                engagementId: (addListing?.engagementId) ? addListing?.engagementId : '',

                agentName: buyeroffer?.agentName,

                agentMobile: buyeroffer?.agentMobile,
                agentEmail: buyeroffer?.agentEmail,
                agentOffice: buyeroffer?.agentOffice,
                agentOfficeName: buyeroffer?.agentOfficeName,
                agentOfficePhone: buyeroffer?.agentOfficePhone,
                clientName: buyeroffer?.clientName,
                clientMobile: buyeroffer?.clientMobile,
                clientPhone: buyeroffer?.clientPhone,
                clientEmail: buyeroffer?.clientEmail,
                conditions: buyeroffer?.clientDealConditionStates
                  .filter(c => c.status === true)
                  .map(c => c.clientDealConditionId.toString())
              }}
              validationSchema={Yup.object().shape({

                statusId: Yup.string().required("This is Required"),
                //propertyType: Yup.string().required("This is Required"),
                //statusId: Yup.string().required("This is Required"),
                //engagementId: Yup.string().required("This is Required"),
                offerDate: Yup.string()
                  .nullable()
                  .required("This is Required"),
              })}

              onSubmit={(values) => {
                if (buyeroffer && buyeroffer.id) {
                  this.offerUpdated(values); // Call offerUpdated if buyeroffer exists
                } else {
                  this.offerSubmitted(values); // Call offerSubmitted if buyeroffer is empty
                }
              }}

            >
              {({ errors, touched, values, handleChange, setFieldValue, setFieldTouched }) => (
                <Form
                  className="needs-validation"
                >
                  <Row>
                    {/* <Col sm="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="statusId">
                                {this.props.t("Property Status")}
                              </Label>
                              <SafeField as="select" name="listingStatusId"
                                //disabled={true}
                                className={
                                  "form-control" +
                                  (errors.listingStatusId && touched.listingStatusId
                                    ? " is-invalid"
                                    : "")
                                }

                                onChange={handleChange}>
                                <option value="">Select</option>
                                <option value="1">Available </option>
                                <option value="2">Not Available</option>
                                <option value="3">Sold</option>
                                <option value="4">Sold Conditionally</option>
                               
                              </SafeField>
                              <ErrorMessage
                                name="listingType"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col> */}
                    <Col sm="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="statusId">
                          {this.props.t("Offer Status *")}
                        </Label>
                        <SafeField as="select" name="statusId"
                          className={
                            "form-control" +
                            (errors.statusId && touched.statusId
                              ? " is-invalid"
                              : "")
                          }

                          onChange={handleChange}>
                          <option value="">Select</option>
                          {map(transStatusTypes, (transStatusType, classkey) => (
                            <option value={transStatusType.id} key={classkey}>{transStatusType.title}</option>
                          ))}

                        </SafeField>
                        <ErrorMessage
                          name="statusId"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col sm="4">
                      <ClientEngagementList name="engagementId" clientId={this.props.match.params.id} agentId={localStorage.getItem('userId')} typeId={1} statusId={0} selectedData={buyeroffer?.engagementId} />
                    </Col>
                    <Col sm="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="mlsId">
                          {this.props.t("Id/MLS#")}
                        </Label>
                        <SafeField
                          name="mlsId"
                          onChange={handleChange}
                          type="text"

                          className={
                            "form-control" +
                            (errors.mlsId && touched.mlsId
                              ? " is-invalid"
                              : "")
                          }

                          id="mlsurl"
                        />
                        <ErrorMessage
                          name="statusId"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>

                    <Col sm="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="address">
                          {this.props.t("Property Address")}
                        </Label>
                        <PlacesAutocomplete
                          value={values.propertyAddress}
                          onChange={(value) => setFieldValue(`propertyAddress`, value)}
                        //onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                        >
                          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div>
                              <input
                                {...getInputProps({
                                  placeholder: 'Enter Address...',
                                  className: 'form-control',

                                })}
                              />
                              <div className="">
                                {loading ? <div>Loading...</div> : null}

                                {suggestions.map((suggestion, i) => {
                                  const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                  const style = suggestion.active
                                    ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                    : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                                  return (
                                    <div
                                      key={i}
                                      {...getSuggestionItemProps(suggestion, {
                                        style,
                                      })}
                                    >
                                      {suggestion.description}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </PlacesAutocomplete>

                        <ErrorMessage
                          name={`propertyAddress`}
                          component="div"
                          className="invalid-feedback"
                        />

                      </FormGroup>
                    </Col>
                    <Col sm="12">
                      <h4 style={{ paddingTop: 0 }}>Offer details</h4>
                    </Col>
                    <Col sm="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="offerDate">
                          {this.props.t("Offer Date *")}
                        </Label>
                        <Flatpickr
                          className={
                            "form-control" +
                            (errors.offerDate && touched.offerDate
                              ? " is-invalid"
                              : "")
                          }
                          placeholder=""
                          value={values.offerDate}
                          onChange={(value) => setFieldValue('offerDate', value[0])}
                          options={{
                            altInput: false,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d"
                          }}
                        />

                        <ErrorMessage name="offerDate" component="div" className="invalid-feedback" />
                      </FormGroup>
                    </Col>
                    {values.buyerType == 1 && (
                      <>
                        <Col sm="4">
                          <FormGroup className="mb-3">
                            <Label htmlFor="agreementStartDate">
                              {this.props.t("Rental start date")}
                            </Label>
                            <Flatpickr
                              className={
                                "form-control" +
                                (errors.agreementStartDate && touched.agreementStartDate
                                  ? " is-invalid"
                                  : "")
                              }
                              placeholder=""
                              value={values.agreementStartDate}
                              onChange={(value) => setFieldValue('agreementStartDate', value[0])}
                              options={{
                                altInput: true,
                                altFormat: "F j, Y",
                                dateFormat: "Y-m-d"
                              }}
                            />


                          </FormGroup>
                        </Col>
                        <Col sm="4">
                          <FormGroup className="mb-3">
                            <Label htmlFor="agreementEndDate">
                              {this.props.t("Rental end date")}
                            </Label>
                            <Flatpickr
                              className={
                                "form-control" +
                                (errors.agreementEndDate && touched.agreementEndDate
                                  ? " is-invalid"
                                  : "")
                              }
                              placeholder=""
                              value={values.agreementEndDate}
                              onChange={(value) => setFieldValue('agreementEndDate', value[0])}
                              options={{
                                altInput: true,
                                altFormat: "F j, Y",
                                dateFormat: "Y-m-d"
                              }}
                            />


                          </FormGroup>
                        </Col>
                      </>
                    )}

                    {/* <Col sm="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="askingPrice">
                          {this.props.t("Asking Price")}
                        </Label>
                        <CurrencyInput
                          name="askingPrice"
                          value={values.askingPrice}
                          className="form-control"
                          onValueChange={(value) => setFieldValue('askingPrice', value)}
                          prefix={userdetail.agentDefaultCurrencyCode}
                          decimalsLimit={2}


                        />
                      
                        <ErrorMessage
                          name="askingPrice"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col> */}
                    <Col sm="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="offerPrice">
                          {this.props.t("Offer price")}
                        </Label>
                        <CurrencyInput
                          name="offerPrice"
                          value={values.offerPrice}
                          className="form-control"
                          onValueChange={(value) => setFieldValue('offerPrice', value)}
                          prefix={userdetail.agentDefaultCurrencyCode + " "}
                          decimalsLimit={2}


                        />

                        <ErrorMessage
                          name="offerPrice"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col sm="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="deposit">
                          {this.props.t("Deposit amount")}
                        </Label>
                        <CurrencyInput
                          name="deposit"
                          value={values.deposit}
                          className="form-control"
                          onValueChange={(value) => setFieldValue('deposit', value)}
                          prefix={userdetail.agentDefaultCurrencyCode + " "}
                          decimalsLimit={2}


                        />

                        <ErrorMessage
                          name="deposit"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col sm="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="closingDate">
                          {this.props.t("Closing Date")}
                        </Label>
                        <Flatpickr
                          className={
                            "form-control" +
                            (errors.closingDate && touched.closingDate
                              ? " is-invalid"
                              : "")
                          }
                          placeholder=""
                          value={values.closingDate}
                          onChange={(value) => setFieldValue('closingDate', value[0])}
                          options={{
                            altInput: true,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d",
                            minDate: 'today'
                          }}
                        />


                      </FormGroup>
                    </Col>

                    <Col sm="3">
                      <FormGroup className="mb-3">
                        <Label htmlFor="offerExpiry">
                          {this.props.t("Offer expiry date")}
                        </Label>
                        <Flatpickr
                          className={
                            "form-control" +
                            (errors.expiryDate && touched.expiryDate
                              ? " is-invalid"
                              : "")
                          }
                          placeholder=""
                          value={values.expiryDate}
                          onChange={(value) => setFieldValue('expiryDate', value[0])}
                          options={{
                            altInput: true,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d",
                            minDate: 'today'
                          }}
                        />


                      </FormGroup>
                    </Col>

                    <Col sm="3">
                      <TimePicker
                        name="expiryTime"
                        label="Start Time"
                        value={values.expiryTime}
                        onChange={(val) => setFieldValue("expiryTime", val)}
                        onBlur={() => setFieldTouched("expiryTime", true)}
                        minTime={null}
                        error={errors.expiryTime}
                        touched={touched.expiryTime}
                      />

                    </Col>
                    <Col sm="12">
                      <h4 style={{ paddingTop: 0 }}>Condition/clauses</h4>
                    </Col>
                    <Col sm="12">

                      {map(allConditions, (condition, index) => (
                        <div key={index} className="form-check form-check-inline">
                          <FormGroup className="mb-3">
                            <SafeField
                              type="checkbox"
                              name="conditions"
                              value={condition.id.toString()}
                              className="form-check-input"
                              id={`condition-${index}`}
                            />
                            <label className="form-check-label" htmlFor={`condition-${index}`}>
                              {condition.dealCondition}
                            </label>
                          </FormGroup>
                        </div>
                      ))}
                    </Col>
                    <Col sm="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="notes">
                          {this.props.t("Special requests/clauses/conditions/notes")}
                        </Label>
                        <textarea
                          name="notes"
                          onChange={handleChange}
                          type="textarea"
                          value={values.notes}
                          className={
                            "form-control" +
                            (errors.notes && touched.notes
                              ? " is-invalid"
                              : "")
                          }
                          id="notes"
                        />
                        <ErrorMessage
                          name="notes"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>

                    </Col>
                    <Col sm="12">
                      <h4 style={{ paddingTop: 0 }}>Listing Agent</h4>
                    </Col>
                    {/* <Col sm="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="propertyType">
                          {this.props.t("Type")}
                        </Label>
                        <SafeField as="select" name="propertyType"
                          className={
                            "form-control" +
                            (errors.propertyType && touched.propertyType
                              ? " is-invalid"
                              : "")
                          }

                          onChange={handleChange}>
                          <option value="">Select</option>
                          {map(listingtypes, (listingtype, classkey) => (
                            <option key={classkey} value={listingtype.listingTypeTitle}>{listingtype.listingTypeTitle}</option>
                          ))}
                        </SafeField>
                        <ErrorMessage
                          name="propertyType"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col> */}
                    {/* <Col sm="8">
                      <FormGroup className="mb-3">
                        <Label htmlFor="propertyURL">
                          {this.props.t("Property URL link")}
                        </Label>
                        <SafeField
                          name="propertyURL"
                          onChange={handleChange}
                          type="text"

                          className={
                            "form-control" +
                            (errors.propertyURL && touched.propertyURL
                              ? " is-invalid"
                              : "")
                          }

                          id="mlsurl"
                        />
                        <ErrorMessage
                          name="propertyURL"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col> */}






                    {/* <h4 style={{ paddingTop: 0 }}>Agent Info</h4> */}
                    <Row>
                      <Col sm="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="agentName">{this.props.t("Name")}</Label>
                          <SafeField type="text" name="agentName" className="form-control" />
                          <ErrorMessage name="agentName" component="div" className="invalid-feedback" />
                        </FormGroup>
                      </Col>
                      <Col sm="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="agentOfficeName">{this.props.t("Office name")}</Label>
                          <SafeField type="text" name="agentOfficeName" className="form-control" />
                          <ErrorMessage name="agentOfficeName" component="div" className="invalid-feedback" />
                        </FormGroup>
                      </Col>
                      <Col sm="6">
                        <FormGroup className="mb-3">
                          <PhoneInputField
                            label="Phone"
                            name="agentMobile"
                            value={values.mobile}
                            setFieldValue={setFieldValue}
                            error={errors.agentMobile}
                            touched={touched.agentMobile}
                            country="ca"
                            required={false}
                          />

                        </FormGroup>
                      </Col>
                      <Col sm="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="agentEmail">{this.props.t("Email")}</Label>
                          <SafeField type="text" name="agentEmail" className="form-control" />
                          <ErrorMessage name="agentEmail" component="div" className="invalid-feedback" />
                        </FormGroup>
                      </Col>
                    </Row>

                    {/* <h4 style={{ paddingTop: 0 }}>Client Info</h4> */}
                    {/* <Row>
                      <Col sm="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="clientName">{this.props.t("Name")}</Label>
                          <SafeField type="text" name="clientName" className="form-control" />
                          <ErrorMessage name="clientName" component="div" className="invalid-feedback" />
                        </FormGroup>
                      </Col>
                      <Col sm="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="clientEmail">{this.props.t("Email")}</Label>
                          <SafeField type="text" name="clientEmail" className="form-control" />
                          <ErrorMessage name="clientEmail" component="div" className="invalid-feedback" />
                        </FormGroup>
                      </Col>
                      <Col sm="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="clientMobile">{this.props.t("Primary Phone")}</Label>
                          <SafeField type="text" name="clientMobile" className="form-control" />
                          <ErrorMessage name="clientMobile" component="div" className="invalid-feedback" />
                        </FormGroup>
                      </Col>
                      <Col sm="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="clientPhone">{this.props.t("Secondary Phone")}</Label>
                          <SafeField type="text" name="clientPhone" className="form-control" />
                          <ErrorMessage name="clientPhone" component="div" className="invalid-feedback" />
                        </FormGroup>
                      </Col>
                    </Row>      */}

                    {/* <Col sm="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="commissionTypeId">
                          {this.props.t("Commision Type")}
                        </Label>
                        <SafeField as="select" name="commissionTypeId" id="commissionTypeId" className={
                          "form-control" +
                          (errors.commision_type && touched.commision_type
                            ? " is-invalid"
                            : "")
                        }
                          onChange={handleChange}>
                          <option value="">Select</option>
                          {map(transactionCommTypes, (transactionCommType, classkey) => (
                            <option value={transactionCommType.id} key={classkey}>{transactionCommType.title}</option>
                          ))}

                        </SafeField>
                        <ErrorMessage
                          name="commissionTypeId"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>

                    </Col>


                    <Col sm="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="commisisonValue">
                          {this.props.t("Commission value ")}
                        </Label>
                        <SafeField
                          name="commisisonValue"
                          onChange={handleChange}
                          type="text"

                          className={
                            "form-control" +
                            (errors.commisisonValue && touched.commisisonValue
                              ? " is-invalid"
                              : "")
                          }

                          id="mls"
                        />
                        <ErrorMessage
                          name="commisisonValue"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>

                    </Col> */}




                    {/* <Col sm="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="notes">
                          {this.props.t("Note")}
                        </Label>
                        <textarea
                          name="notes"
                          onChange={handleChange}
                          type="textarea"
                          value={values.notes}
                          className={
                            "form-control" +
                            (errors.notes && touched.notes
                              ? " is-invalid"
                              : "")
                          }
                          id="notes"
                        />
                        <ErrorMessage
                          name="notes"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>

                    </Col> */}
                    <Col sm="12">
                      <div className="clearfix">

                        <UpdateButton>{this.props.t("Update")}</UpdateButton>{" "} <RsLink onClick={this.toggleOfferAccepted}>Close</RsLink>
                      </div>
                    </Col>
                  </Row>

                </Form>
              )}
            </Formik>

          </OffcanvasBody>
        </Offcanvas>

        <Offcanvas
          isOpen={this.state.isRoute}
          direction="end"
          toggle={this.toggleCreateRoute}
          style={{ width: 600 }}
        >
          <OffcanvasHeader toggle={this.toggleCreateRoute}>
            Create Route
          </OffcanvasHeader>
          <OffcanvasBody>
            <Nav pills className="navtab-bg nav-justified">
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab2 === "1",
                  })}
                  onClick={() => {
                    this.toggle2("1");
                  }}
                >
                  Current plans
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab2 === "2",
                  })}
                  onClick={() => {
                    this.toggle2("2");
                  }}
                >
                  New
                </NavLink>
              </NavItem>

            </Nav>
            <TabContent activeTab={this.state.activeTab2} className="p-3 text-muted">

              <TabPane tabId="1">
                {routeData?.length > 0 ? (
                  <div className="accordion" id="accordion">
                    {routeData?.map((route, index) => (
                      <div className="accordion-item" key={index}>
                        <h2 className="accordion-header" id={`heading${index}`}>
                          <button
                            className={`accordion-button fw-medium  ${this.state[`col${index}`] ? "" : "collapsed"}`}
                            type="button"
                            onClick={() => this.toggleCollapse(index)}
                            style={{ cursor: "pointer" }}

                          >
                            <div>
                              {route.forDate ? (
                                <>
                                  <Moment format="MMM DD YYYY">{route.forDate}</Moment>
                                  {route.forTime && (
                                    <>
                                      &nbsp;{" @ "}&nbsp;
                                      {route.forTime}
                                    </>
                                  )}
                                </>
                              ) : (
                                "No Date"
                              )}
                            </div>

                          </button>


                        </h2>

                        <Collapse
                          isOpen={this.state[`col${index}`]}
                          className="accordion-collapse"
                        >
                          <div className="accordion-body">
                            <div className="text-muted">
                              {/* <span className="float-end"><ActionEdit onClick={()=>this.editRoute(route)} /> </span> */}
                              <table className="align-middle mb-0 table">
                                <thead>
                                  <tr>
                                    <th>Order</th>
                                    <th>MLS#</th>
                                    <th>Address</th>
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {route.clientPotentialListingsShowingRouteItems?.map((item, idx) => (
                                    <tr key={idx}>
                                      <td>{item.routeOrder}</td>
                                      <td>{item?.listing?.mlsId}</td>
                                      <td>{item?.listing?.listingAddress}</td>
                                      <td><ActionDelete onClick={() => this.handleDeleteRoute(item)} /></td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                            {this.state.showEditForm && (
                              <div id="edit-frm">
                                <Formik
                                  enableReinitialize={true}
                                  initialValues={{
                                    forDate: new Date(routeData?.forDate),
                                    forTime: routeData?.forTime,

                                    createClientPotentialListingsShowingRouteLists: filteredAddListings.map((listing, index) => ({

                                      clientId: parseInt(this.props.match.params.id),
                                      agentId: parseInt(localStorage.getItem('userId')),
                                      clientPotentialListingId: parseInt(listing.id),
                                      routeOrder: "",
                                      forDate: momemt,
                                      forTime: "",
                                    })),
                                  }}
                                  validationSchema={Yup.object().shape({



                                  })}

                                  onSubmit={(values, { setSubmitting }) => {

                                    const filteredData = values.createClientPotentialListingsShowingRouteLists
                                      .filter((item) => item.routeOrder !== "")
                                      .map((item) => ({
                                        ...item,
                                        forDate: moment(values.forDate).format("YYYY-MM-DD"),
                                        forTime: moment(values.forTime).format("HH:mm:ss"),
                                      }));
                                    const obj = JSON.parse(localStorage.getItem("authUser"));
                                    const token = obj?.resultData?.bearerToken;
                                    axios.post(`${API_URL}ClientPotentialListingsShowingRoute/bulkadd`, { createClientPotentialListingsShowingRouteLists: filteredData }, {
                                      headers: {
                                        "Content-Type": "application/json",
                                        'Authorization': `Bearer ${token}`,
                                      },
                                    })
                                      .then((response) => {
                                        
                                      })
                                      .catch((error) => {
                                        console.error("Error:", error);
                                      })
                                      .finally(() => setSubmitting(false));
                                  }}

                                >
                                  {({ errors, touched, values, handleChange, setFieldValue }) => {
                                    // Collect already selected routeOrder values
                                    const selectedOrders = values.createClientPotentialListingsShowingRouteLists
                                      .map((item) => item.routeOrder)
                                      .filter((order) => order !== "");

                                    return (
                                      <Form className="needs-validation">
                                        <Row>

                                          {filteredAddListings.map((addListingRoute, index) => {
                                            // Available order options excluding already selected ones
                                            const availableOrders = Array.from({ length: addListings.length }, (_, i) => i + 1).filter(
                                              (num) => !selectedOrders.includes(num) || num === values.createClientPotentialListingsShowingRouteLists[index]?.routeOrder
                                            );

                                            return (
                                              <React.Fragment key={index}>
                                                <Col sm="4">
                                                  <FormGroup className="mb-3">
                                                    <Label htmlFor={`routeOrder_${index}`}>
                                                      {this.props.t("Order")}
                                                    </Label>
                                                    <SafeField
                                                      as="select"
                                                      name={`createClientPotentialListingsShowingRouteLists[${index}].routeOrder`}
                                                      id={`routeOrder_${index}`}
                                                      className={
                                                        "form-control" +
                                                        (errors.routeOrder && touched.routeOrder ? " is-invalid" : "")
                                                      }
                                                      onChange={(e) => {
                                                        setFieldValue(
                                                          `createClientPotentialListingsShowingRouteLists[${index}].routeOrder`,
                                                          parseInt(e.target.value, 10)
                                                        );
                                                      }}
                                                    >
                                                      <option value="">Select</option>
                                                      {availableOrders.map((num) => (
                                                        <option key={num} value={num}>
                                                          {num}
                                                        </option>
                                                      ))}
                                                    </SafeField>

                                                    <ErrorMessage
                                                      name={`createClientPotentialListingsShowingRouteLists[${index}].routeOrder`}
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </FormGroup>
                                                </Col>

                                                <Col sm="8">
                                                  <FormGroup className="mb-3">
                                                    <Label htmlFor="address">&nbsp;</Label>
                                                    <h5>{addListingRoute.mlsId}</h5>
                                                    <h5>Address: {addListingRoute.listingAddress}</h5>
                                                  </FormGroup>
                                                </Col>
                                              </React.Fragment>
                                            );
                                          })}

                                          <Col sm="12">
                                            <div className="clearfix">
                                              <SaveButton>{this.props.t("Save")}</SaveButton>
                                            </div>
                                          </Col>
                                        </Row>


                                      </Form>
                                    );
                                  }}
                                </Formik>

                              </div>
                            )}
                          </div>
                        </Collapse>
                      </div>
                    ))}
                  </div>
                ) : (
                  <Alert color="danger">
                    No route plans available
                  </Alert>
                )}
              </TabPane>
              <TabPane tabId="2">
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    clientId: parseInt(this.props.match.params.id),
                    agentId: parseInt(localStorage.getItem('userId')),
                    forDate: "",
                    forTime: "",
                  }}
                  validationSchema={Yup.object().shape({
                    forDate: Yup.string()
                      .nullable()
                      .required("This is Required"),


                  })}

                  onSubmit={this.handleForDateTimeChange}

                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => {
                    return (
                      <Form className="needs-validation">
                        <Row>
                          <Col sm="5">
                            <FormGroup className="mb-3">
                              <Label htmlFor="forDate">{this.props.t("Date *")}</Label>

                              <Flatpickr
                                className={
                                  "form-control" +
                                  (errors.forDate && touched.forDate ? " is-invalid" : "")
                                }
                                placeholder=""
                                value={values.forDate}
                                onChange={(value) => setFieldValue("forDate", value[0])}
                                options={{
                                  altInput: false,
                                  minDate: "today",
                                  altFormat: "F j, Y",
                                  dateFormat: "Y-m-d",
                                }}
                              />
                              <ErrorMessage name="forDate" component="div" className="invalid-feedback" />
                            </FormGroup>
                          </Col>

                          <Col sm="2">
                            <div style={{ marginTop: "30px" }}></div>
                            <SaveButton iconClass="bx bx-search">{this.props.t("Go")}</SaveButton>
                          </Col>
                        </Row>


                      </Form>
                    );
                  }}
                </Formik>
                {this.state.noFound && (
                  this.state.showingListings?.length > 0 ? (
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        createClientPotentialListingsShowingRouteLists: this.state.showingListings?.map((listing, index) => {
                          return {
                            clientId: parseInt(this.props.match.params.id),
                            agentId: parseInt(localStorage.getItem('userId')),
                            clientPotentialListingId: parseInt(listing?.listing?.id),
                            routeOrder: "",
                            forDate: listing?.listing?.showingDate,
                            forTime: '',
                          };
                        })
                      }}
                      validationSchema={Yup.object().shape({
                        createClientPotentialListingsShowingRouteLists: Yup.array().of(
                          Yup.object().shape({
                            routeOrder: Yup.number()
                              .typeError("Order is required")
                              .required("Order is required"),
                          })
                        ),
                        forTime: Yup.string()
                          .nullable()
                          .required("Start time is required"),
                      })}

                      onSubmit={(values, { setSubmitting }) => {

                        const filteredData = values.createClientPotentialListingsShowingRouteLists
                          .filter((item) => item.routeOrder !== "")
                          .map((item) => ({
                            ...item,
                            forDate: moment(item.forDate).format("YYYY-MM-DD"),
                            forTime: values.forTime,
                          }));
                        //
                        const obj = JSON.parse(localStorage.getItem("authUser"));
                        const token = obj?.resultData?.bearerToken;
                        toast.loading("Please wait...");
                        axios.post(`${API_URL}ClientPotentialListingsShowingRoute/bulkadd`, { createClientPotentialListingsShowingRouteLists: filteredData }, {
                          headers: {
                            "Content-Type": "application/json",
                            'Authorization': `Bearer ${token}`,
                          },
                        })
                          .then((response) => {
                            if (response.data.success === true) {
                              toast.dismiss();
                              toast.success("Saved successfully");
                              this.fetchRouteData();
                              //
                            }
                          })
                          .catch((error) => {
                            console.error("Error:", error);
                          })
                          .finally(() => setSubmitting(false));
                      }}

                    >
                      {({ errors, touched, values, handleChange, setFieldValue, setFieldTouched }) => {
                        // Collect already selected routeOrder values
                        const selectedOrders = values.createClientPotentialListingsShowingRouteLists
                          .map((item) => item.routeOrder)
                          .filter((order) => order !== "");

                        return (
                          <Form className="needs-validation">
                            <Row>

                              {this.state.showingListings?.map((addListingRoute, index) => {

                                const availableOrders = Array.from({ length: this.state.showingListings?.length }, (_, i) => i + 1).filter(
                                  (num) => !selectedOrders.includes(num) || num === values.createClientPotentialListingsShowingRouteLists[index]?.routeOrder
                                );

                                return (
                                  <React.Fragment key={index}>
                                    <Col sm="4">
                                      {addListingRoute?.listing?.listingStatusId === 1 ? (
                                        <FormGroup className="mb-3">
                                          <Label htmlFor={`routeOrder_${index}`}>
                                            {this.props.t("Order *")}
                                          </Label>
                                          <SafeField
                                            as="select"
                                            name={`createClientPotentialListingsShowingRouteLists[${index}].routeOrder`}
                                            id={`routeOrder_${index}`}
                                            className={
                                              "form-control" +
                                              (errors.createClientPotentialListingsShowingRouteLists?.[index]?.routeOrder &&
                                                touched.createClientPotentialListingsShowingRouteLists?.[index]?.routeOrder
                                                ? " is-invalid"
                                                : "")
                                            }
                                            onChange={(e) => {
                                              setFieldValue(
                                                `createClientPotentialListingsShowingRouteLists[${index}].routeOrder`,
                                                parseInt(e.target.value, 10)
                                              );
                                            }}
                                          >
                                            <option value="">Select</option>
                                            {availableOrders.map((num) => (
                                              <option key={num} value={num}>
                                                {num}
                                              </option>
                                            ))}
                                          </SafeField>

                                          <ErrorMessage
                                            name={`createClientPotentialListingsShowingRouteLists[${index}].routeOrder`}
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </FormGroup>
                                      ) : (
                                        <>
                                          <FormGroup className="mb-3">
                                            <Label htmlFor="address">&nbsp;</Label>
                                            <h5 style={{ color: "red" }}>Route not available</h5>
                                          </FormGroup>
                                        </>
                                      )}

                                    </Col>

                                    <Col sm="8">
                                      <FormGroup className="mb-3">
                                        <Label htmlFor="address">&nbsp;</Label>
                                        <h5>Id: {addListingRoute?.listing?.mlsId} - <strong>{addListingRoute?.listing?.startTime + "-" + addListingRoute?.listing?.endTime}</strong></h5>
                                        <h5>Address: {addListingRoute?.listing?.listingAddress}</h5>
                                      </FormGroup>
                                    </Col>

                                  </React.Fragment>
                                );
                              })}
                              <Col sm="5">
                                <TimePicker
                                  name="forTime"
                                  label="Set start time *"
                                  value={values.forTime}
                                  onChange={(val) => setFieldValue("forTime", val)}
                                  onBlur={() => setFieldTouched("forTime", true)}
                                  minTime={null}
                                  error={errors.forTime}
                                  touched={touched.forTime}
                                  required={true}
                                />
                                <ErrorMessage name="forTime" component="div"
                                  className="invalid-feedback" />

                                {/* <FormGroup className="mb15">

                                <Label htmlFor="forTime">
                                  {this.props.t("Start Time")}
                                </Label>
                                <InputGroup>
                                  <Flatpickr
                                    className="form-control d-block"
                                    placeholder="Select time"

                                    onChange={(value) => setFieldValue('forTime', value[0])}
                                    options={{
                                      enableTime: true,
                                      noCalendar: true,
                                      dateFormat: "h:i"
                                    }}
                                  />
                                  <div className="input-group-append">
                                    <span className="input-group-text">
                                      <i className="mdi mdi-clock-outline" />
                                    </span>
                                  </div>
                                </InputGroup>

                              </FormGroup> */}
                              </Col>
                              <Col sm="12">
                                <div className="clearfix">
                                  <SaveButton>{this.props.t("Save")}</SaveButton>
                                </div>
                              </Col>
                            </Row>


                          </Form>
                        );
                      }}
                    </Formik>
                  ) : (
                    <Alert color="danger">
                      No showings found
                    </Alert>
                  )
                )}
              </TabPane>
            </TabContent>


          </OffcanvasBody>
        </Offcanvas>


        <Offcanvas
          isOpen={this.state.isActivity}
          direction="end"
          toggle={this.canavasbuyeractivity}
          style={{ width: 950 }}
        >
          <OffcanvasHeader toggle={this.canavasbuyeractivity}>
            Buyer Activity
          </OffcanvasHeader>
          <OffcanvasBody>
            <DataTable
              className=""
              stripedRows
              value={this.state.clientActivities || []}
              paginator
              rows={10}
              rowsPerPageOptions={[10, 20, 30, 50, 100, 150, 200, 500]}
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              tableStyle={{ minWidth: "50rem" }}
            >
              <Column
                header="#"
                body={(rowData, options) => options.rowIndex + 1}
                style={{ width: '60px' }}
              />

              <Column
                headerClassName="header-bg-table"
                field="showingDate"
                header="Date"
                body={(rowData) =>
                  rowData.addedDate ? <Moment format="DD MMM, YYYY">{rowData.addedDate}</Moment> : "N/A"
                }
              />

              <Column headerClassName="header-bg-table" field="clientListingActivityListing" header="Listing Id" body={(rowData) => rowData.clientListingActivityListing || "N/A"} />

              <Column headerClassName="header-bg-table" style={{ width: '400px' }} field="clientListingActivityListingAddress" header="Listing Address" body={(rowData) => rowData.clientListingActivityListingAddress} />
              {/* <Column
                headerClassName="header-bg-table"
                field="clientListingActivitySubType"
                header="Type"
                body={(rowData) => this.getType(rowData.clientListingActivityType) || "N/A"}
              /> */}
              <Column
                headerClassName="header-bg-table"
                field="clientListingActivitySubType"
                header="Type"
                body={(rowData) => {
                  const type = rowData.clientListingActivityType;
                  const subType = rowData.clientListingActivitySubType;

                  if (type === 1) {
                    return this.getListingSubType(subType) || "N/A";
                  } else if (type === 2) {
                    return this.getSellerListingSubType(subType) || "N/A";
                  } else {
                    return this.getOpenHouse(subType) || "N/A";
                  }
                }}
              />

            </DataTable>


          </OffcanvasBody>
        </Offcanvas>
      </React.Fragment>
    )
  }
}
ClientListing.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  match: PropTypes.object,
  addClientAddListing: PropTypes.func,
  onGetClientDetail: PropTypes.func,
  clietDetail: PropTypes.object,
  addListings: PropTypes.array,
  onGetClientAddListing: PropTypes.func,
  onDeleteAddListing: PropTypes.func,
  onUpdateClientAddListing: PropTypes.func,
  loading: PropTypes.object,
  onGetListingType: PropTypes.func,
  listingtypes: PropTypes.array,
  onGetUserDetail: PropTypes.func,
  userdetail: PropTypes.object,
  onGetTransactonStatusType: PropTypes.func,
  transStatusTypes: PropTypes.array,
  onGetTransactonCommType: PropTypes.func,
  transactionCommTypes: PropTypes.array,
  addClientBuyerOffer: PropTypes.func,
  onGetClientBuyerOffer: PropTypes.func,
  buyeroffer: PropTypes.object,
  updateClientBuyerOffer: PropTypes.func,
  isResponsive: PropTypes.object
}
const mapStateToProps = ({ Clients, AppoinmentObject, Login }) => (
  {
    clietDetail: Clients.clietDetail,
    addListings: Clients.addListings,
    listingtypes: AppoinmentObject.listingtypes,
    loading: Clients.loading,
    userdetail: Login.userdetail,
    transStatusTypes: AppoinmentObject.transStatusTypes,
    transactionCommTypes: AppoinmentObject.transactionCommTypes,
    buyeroffer: Clients.buyeroffer,
  })
const mapDispatchToProps = dispatch => ({
  onGetClientDetail: clientId => dispatch(getClientDetail(clientId)),
  onGetListingType: agentId => dispatch(getListingType(agentId)),
  addClientAddListing: (data, callback) => dispatch(addClientAddListing(data, callback)),
  onGetClientAddListing: (clientId, agentId) => dispatch(getClientAddListing(clientId, agentId)),
  onDeleteAddListing: (id) => dispatch(deleteClientAddListing(id)),
  onUpdateClientAddListing: (data, callback) => dispatch(ClientAddListingUpdate(data, callback)),
  onGetUserDetail: agentId => dispatch(getUserDetail(agentId)),
  onGetTransactonStatusType: (agentId, forType) => dispatch(getTransStatusType(agentId, forType)),
  onGetTransactonCommType: (agentId) => dispatch(getTransCommType(agentId)),
  addClientBuyerOffer: (data) => dispatch(addClientBuyerOffer(data)),
  onGetClientBuyerOffer: (refId) => dispatch(getClientBuyerOffer(refId)),
  updateClientBuyerOffer: (data, callback) => dispatch(updateClientBuyerOffer(data, callback))

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ClientListing))
